import SettingsIcon from "examples/Icons/Settings";
import Office from "examples/Icons/Office";
import CreditCard from "examples/Icons/CreditCard";
import Shop from "examples/Icons/Shop";
import Basket from "examples/Icons/Basket";
import Document from "examples/Icons/Document";
import Cube from "examples/Icons/Cube";
import AccountingAccounts from "layouts/manage-accounting-account";
import AccountingAccountsTT99 from "layouts/manage-accounting-account-tt99";
import AccountingAccountsTT133 from "layouts/manage-accounting-account-tt133";
import AccountingAccountsTT132 from "layouts/manage-accounting-account-tt132";
import AccountingAccountsTT200 from "layouts/manage-accounting-account-tt200";
import { ADMIN, CS, SUPER_ADMIN, USER } from "constants/roles.constant";
import BusinessCode from "layouts/manage-business";

import Companies from "layouts/manage-companies";
import CompanyDetail from "layouts/manage-companies/detail";

import Employees from "layouts/manage-employees";
import EmployeeInfo from "layouts/manage-employees/detail";

import BalanceSheet from "layouts/manage-balance-sheet";
import BalanceSheetDetail from "layouts/manage-balance-sheet/detail";

import InvoiceBooks from "layouts/manage-invoice-books";
import InvoiceDetail from "layouts/manage-invoice-books/detail";

import BillsOut from "layouts/manage-bills/bill-out";
import BillOutDetail from "layouts/manage-bills/bill-out/detail";
import BillsIn from "layouts/manage-bills/bill-in";
import BillInDetail from "layouts/manage-bills/bill-in/detail";

import TaxValue01 from "layouts/declarations/tax-value/01/tax-value-01";
import TaxValue02 from "layouts/declarations/tax-value/02/tax-value-02";
import TaxValue03 from "layouts/declarations/tax-value/03/tax-value-03";
import TaxValue04 from "layouts/declarations/tax-value/04/tax-value-04";
import TaxValue05 from "layouts/declarations/tax-value/05/tax-value-05";
import TaxValue06 from "layouts/declarations/tax-value/06/tax-value-06";

import CorporateIncomeTax02 from "layouts/declarations/corporate-income-tax/02/corporate-income-tax-02";
import CorporateIncomeTax03 from "layouts/declarations/corporate-income-tax/03/corporate-income-tax-03";
import CorporateIncomeTax04 from "layouts/declarations/corporate-income-tax/04/corporate-income-tax-04";
import CorporateIncomeTax05 from "layouts/declarations/corporate-income-tax/05/corporate-income-tax-05";
import CorporateIncomeTax06 from "layouts/declarations/corporate-income-tax/06/corporate-income-tax-06";

import TaxPersonal01 from "layouts/declarations/tax-personal/01/tax-personal-01";
import TaxPersonal02 from "layouts/declarations/tax-personal/02/tax-personal-02";
import TaxPersonal03 from "layouts/declarations/tax-personal/03/tax-personal-03";
import TaxPersonal04 from "layouts/declarations/tax-personal/04/tax-personal-04";
import TaxPersonal05 from "layouts/declarations/tax-personal/05/tax-personal-05";
import TaxPersonal06 from "layouts/declarations/tax-personal/06/tax-personal-06";
import TaxPersonal07 from "layouts/declarations/tax-personal/07/tax-personal-07";
import TaxPersonal08 from "layouts/declarations/tax-personal/08/tax-personal-08";
import TaxPersonal09 from "layouts/declarations/tax-personal/09/tax-personal-09";
import TaxPersonal10 from "layouts/declarations/tax-personal/10/tax-personal-10";
import TaxPersonal11 from "layouts/declarations/tax-personal/11/tax-personal-11";
import TaxPersonal12 from "layouts/declarations/tax-personal/12/tax-personal-12";
import TaxPersonal13 from "layouts/declarations/tax-personal/13/tax-personal-13";
import TaxPersonal14 from "layouts/declarations/tax-personal/14/tax-personal-14";
import TaxPersonal15 from "layouts/declarations/tax-personal/15/tax-personal-15";
import TaxPersonal16 from "layouts/declarations/tax-personal/16/tax-personal-16";

import Fct01NTNN from "layouts/declarations/foreign-contractor-tax/01-NTNN/fct-01-NTNN-TT80-2021";
import Fct02NTNN from "layouts/declarations/foreign-contractor-tax/02-NTNN/fct-02-NTNN-TT80-2021";
import Fct03NTNN from "layouts/declarations/foreign-contractor-tax/03-NTNN/fct-03-NTNN-TT80-2021";
import Fct04NTNN from "layouts/declarations/foreign-contractor-tax/04-NTNN/fct-04-NTNN-TT80-2021";
import Fct01HKNN from "layouts/declarations/foreign-contractor-tax/01-HKNN/fct-01-HKNN";
import Fct01VTNN from "layouts/declarations/foreign-contractor-tax/01-VTNN/fct-01-VTNN";
import Fct01TBH from "layouts/declarations/foreign-contractor-tax/01-TBH/fct-01-TBH";

import ResourceTax01 from "layouts/declarations/resource-tax/01/resource-tax-01";
import ResourceTax02 from "layouts/declarations/resource-tax/02/resource-tax-02";

import ConsumptionTax01 from "layouts/declarations/consumption-tax/01/consumption-tax-01";
import ConsumptionTax02 from "layouts/declarations/consumption-tax/02/consumption-tax-02";

import FinancialReport01 from "layouts/declarations/financial-report/01/financial-report-01";
import FinancialReport02 from "layouts/declarations/financial-report/02/financial-report-02";
import FinancialReport03 from "layouts/declarations/financial-report/03/financial-report-03";
import FinancialReport04 from "layouts/declarations/financial-report/04/financial-report-04";
import FinancialReport05 from "layouts/declarations/financial-report/05/financial-report-05";
import FinancialReport06 from "layouts/declarations/financial-report/06/financial-report-06";
import FinancialReport07 from "layouts/declarations/financial-report/07/financial-report-07";
import FinancialReport08 from "layouts/declarations/financial-report/08/financial-report-08";
import FinancialReport09 from "layouts/declarations/financial-report/09/financial-report-09";
import FinancialReport10 from "layouts/declarations/financial-report/10/financial-report-10";
import FinancialReport11 from "layouts/declarations/financial-report/11/financial-report-11";
import FinancialReport12 from "layouts/declarations/financial-report/12/financial-report-12";
import FinancialReport13 from "layouts/declarations/financial-report/13/financial-report-13";
import FinancialReport14 from "layouts/declarations/financial-report/14/financial-report-14";
import FinancialReport15 from "layouts/declarations/financial-report/15/financial-report-15";
import FinancialReport16 from "layouts/declarations/financial-report/16/financial-report-16";
import FinancialReport17 from "layouts/declarations/financial-report/17/financial-report-17";
import FinancialReport18 from "layouts/declarations/financial-report/18/financial-report-18";
import FinancialReport19 from "layouts/declarations/financial-report/19/financial-report-19";
import FinancialReport20 from "layouts/declarations/financial-report/20/financial-report-20";
import FinancialReport21 from "layouts/declarations/financial-report/21/financial-report-21";
import FinancialReport22 from "layouts/declarations/financial-report/22/financial-report-22";
import FinancialReport23 from "layouts/declarations/financial-report/23/financial-report-23";
import FinancialReport24 from "layouts/declarations/financial-report/24/financial-report-24";

import Bill01 from "layouts/declarations/bill/TB01/bill-01";
import BillBc21 from "layouts/declarations/bill/BC21/bill-BC-21";
import BillBc01 from "layouts/declarations/bill/BC01/bill-BC-01";
import BillTb03 from "layouts/declarations/bill/TB03/bill-TB-03";
import BillBc26 from "layouts/declarations/bill/BC26/bill-BC-26";
import BillBK01 from "layouts/declarations/bill/BK01/bill-BK-01";
import BillTB04 from "layouts/declarations/bill/TB04/bill-TB-04";
import Bill03 from "layouts/declarations/bill/03/bill-03";

import BillPersionalIncome from "layouts/declarations/bill/personalIncome/bill-personal-Income";
import BillQuantityBc26 from "layouts/declarations/bill/quantity-BC26/bill-quantity-BC-26";

import ProtectResourceTax01 from "layouts/declarations/protect-resource/01/protect-resource-tax-01";

import Fee01 from "layouts/declarations/fee/01/fee-01";
import Fee02 from "./layouts/declarations/fee/02/fee-02";
import Fee03 from "layouts/declarations/fee/03/fee-03";
import Fee04 from "layouts/declarations/fee/04/fee-04";
import Fee05 from "layouts/declarations/fee/05/fee-05";
import Fee06 from "layouts/declarations/fee/06/fee-06";
import Fee07 from "layouts/declarations/fee/07/fee-07";
import Fee08 from "layouts/declarations/fee/08/fee-08";

import TaxProperty01 from "layouts/declarations/tax-property/01/tax-property-01";
import TaxProperty02 from "layouts/declarations/tax-property/02/tax-property-02";
import TaxProperty03 from "layouts/declarations/tax-property/03/tax-property-03";

import OilGas01 from "layouts/declarations/oil-gas/01/oil-gas-01";
import OilGas02 from "layouts/declarations/oil-gas/02/oil-gas-02";
import OilGas03 from "layouts/declarations/oil-gas/03/oil-gas-03";
import OilGas04 from "layouts/declarations/oil-gas/04/oil-gas-04";
import OilGas05 from "layouts/declarations/oil-gas/05/oil-gas-05";
import OilGas06 from "layouts/declarations/oil-gas/06/oil-gas-06";
import OilGas07 from "layouts/declarations/oil-gas/07/oil-gas-07";
import OilGas08 from "layouts/declarations/oil-gas/08/oil-gas-08";
import OilGas09 from "layouts/declarations/oil-gas/09/oil-gas-09";
import OilGas10 from "layouts/declarations/oil-gas/10/oil-gas-10";
import OilGas11 from "layouts/declarations/oil-gas/11/oil-gas-11";
import OilGas12 from "layouts/declarations/oil-gas/12/oil-gas-12";
import OilGas13 from "layouts/declarations/oil-gas/13/oil-gas-13";
import OilGas14 from "layouts/declarations/oil-gas/14/oil-gas-14";
import OilGas15 from "layouts/declarations/oil-gas/15/oil-gas-15";
import OilGas16 from "layouts/declarations/oil-gas/16/oil-gas-16";
import OilGas17 from "layouts/declarations/oil-gas/17/oil-gas-17";
import OilGas18 from "layouts/declarations/oil-gas/18/oil-gas-18";
import OilGas19 from "layouts/declarations/oil-gas/19/oil-gas-19";
import OilGas20 from "layouts/declarations/oil-gas/20/oil-gas-20";
import OilGas21 from "layouts/declarations/oil-gas/21/oil-gas-21";

import NotifyOfReceiptIssuance from "layouts/declarations/receipt/notify-of-receipt-issuance/notify_of_receipt_issuance.js";
import ReceiveReceipt from "layouts/declarations/receipt/receive-receipt.js/receive_receipt";
import LostReceipt from "layouts/declarations/receipt/lost-receipt/lost-receipt";
import CancelReceipt from "layouts/declarations/receipt/cancel-receipt/cancel-receipt";
import ReceiptBC7 from "layouts/declarations/receipt/BC-7/receipt-BC-7";
import ReiceiptTB04 from "layouts/declarations/receipt/TB-04/receipt-TB-04";
import UnusedReceipt from "layouts/declarations/receipt/unusedReceipts/unused-receipt";

import CapitalTransfer01 from "layouts/declarations/capital-transfer/01/capital-transfer-01";
import CapitalTransfer02 from "layouts/declarations/capital-transfer/02/capital-transfer-02";
import CapitalTransfer03 from "layouts/declarations/capital-transfer/03/capital-transfer-03";
import CapitalTransfer04 from "layouts/declarations/capital-transfer/04/capital-transfer-04";
import CapitalTransfer05 from "layouts/declarations/capital-transfer/05/capital-transfer-05";
import CapitalTransfer06 from "layouts/declarations/capital-transfer/06/capital-transfer-06";

import CancelWineStamps from "layouts/declarations/wine-stamps/cancel-wine-stamps/cancel-wine-stamps";
import LostWineStamps from "layouts/declarations/wine-stamps/lost-wine-stamps/lost-wine-stamps";
import UseWineStamps from "layouts/declarations/wine-stamps/use-wine-stamps/use-wine-stamps";

import CTLNDCTT80 from "layouts/declarations/stocks/CTLNDC-TT80/ctlndc-tt80";
import QTLNCLTT80 from "layouts/declarations/stocks/QTLNCL-TT80/qtlncl-tt80";

import HT from "layouts/declarations/taxRefund/01-HT/01-ht";
import DNXNLT from "layouts/declarations/taxRefund/01-DNXNLT/01-dnxnlt.js";
import DNHUY from "layouts/declarations/taxRefund/01-DNHUY/01-dnhuy";
import DNHT from "layouts/declarations/taxRefund/01-DNHT/01-dnht";

import TaxPaymentExtension01 from "layouts/declarations/tax-payment-extension/01/01";
import TaxPaymentExtensionND52 from "layouts/declarations/tax-payment-extension/02/02";

import Ecommerce01 from "layouts/declarations/ecommerce/01/ecommerce-01";

import Collateral01 from "layouts/declarations/collateral/01/collateral-01";

import Land01 from "layouts/declarations/land/01/land-01";
import Land02 from "layouts/declarations/land/02/land-02";
import Land03 from "layouts/declarations/land/03/land-03";

import PaymentAccount01 from "layouts/declarations/payment-account/01/payment-account-01";

import ForeignSupplier01 from "layouts/declarations/foreign-supplier/01/foreign-supplier-01";
import ForeignSupplier02 from "layouts/declarations/foreign-supplier/02/foreign-supplier-02";
import Freeofcharge01 from "layouts/declarations/free-of-charge/01/free-of-charge-01";
//
import GeneralJournal from "layouts/accounting-management/general-journal/general-journal";
import AccountingSubsidiaryLedger from "layouts/accounting-management/subsidiary-ledger/subsidiary-ledger";
//
import PayrollPaymentSheet from "layouts/accounting-form/appendix-1/payroll-payment-sheet/payroll-payment-sheet";
import PayrollPaymentSheetDetail from "layouts/accounting-form/appendix-1/payroll-payment-sheet/detail";
//
import BonusPaymentTable from "layouts/accounting-form/appendix-1/bonus-payment-table/bonus-payment-table";
import BonusPaymentTableDetail from "layouts/accounting-form/appendix-1/bonus-payment-table/detail";
import OvertimePaymentTable from "layouts/accounting-form/appendix-1/overtime-payment-table/overtime-payment-table";
import OvertimePaymentTableDetail from "layouts/accounting-form/appendix-1/overtime-payment-table/detail";
import OutsourcingPaymentSchedule from "layouts/accounting-form/appendix-1/outsourcing-payment-schedule/outsourcing-payment-schedule";
import OutsourcingPaymentScheduleDetail from "layouts/accounting-form/appendix-1/outsourcing-payment-schedule/detail";
import ContractForWork from "layouts/accounting-form/appendix-1/contract-for-work/contract-for-work";
import ContractForWorkDetail from "layouts/accounting-form/appendix-1/contract-for-work/detail";
import ContractLiquidationAcceptanceMinutes from "layouts/accounting-form/appendix-1/contract-liquidation-acceptance-minutes/contract-liquidation-acceptance-minutes";
import ContractLiquidationAcceptanceMinutesDetail from "layouts/accounting-form/appendix-1/contract-liquidation-acceptance-minutes/detail";
import PayrollDeductionsRemittanceStatement from "layouts/accounting-form/appendix-1/payroll-deductions-remittance-statement/payroll-deductions-remittance-statement";
import PayrollDeductionsRemittanceStatementDetail from "layouts/accounting-form/appendix-1/payroll-deductions-remittance-statement/detail";
import PayrollDistributionSchedule from "layouts/accounting-form/appendix-1/payroll-distribution-schedule/payroll-distribution-schedule";
import PayrollDistributionScheduleDetail from "layouts/accounting-form/appendix-1/payroll-distribution-schedule/detail";
import GoodsReceivedNote from "layouts/accounting-form/appendix-1/goods-received-note/goods-received-note";
import GoodsReceivedNoteDetail from "layouts/accounting-form/appendix-1/goods-received-note/detail";
import GoodsDeliveryNote from "layouts/accounting-form/appendix-1/goods-delivery-note/goods-delivery-note";
import GoodsDeliveryNoteDetail from "layouts/accounting-form/appendix-1/goods-delivery-note/detail";
import VerificationReport from "layouts/accounting-form/appendix-1/verification-report/verification-report";
import VerificationReportDetail from "layouts/accounting-form/appendix-1/verification-report/detail";
import MaterialsStockReport from "layouts/accounting-form/appendix-1/materials-stock-report/materials-stock-report";
import MaterialsStockReportDetail from "layouts/accounting-form/appendix-1/materials-stock-report/detail";
import InventorySummaryReport from "layouts/accounting-form/appendix-1/inventory-summary-report/inventory-summary-report";
import InventorySummaryReportDetail from "layouts/accounting-form/appendix-1/inventory-summary-report/detail";
import PurchaseOrder from "layouts/accounting-form/appendix-1/purchase-order/purchase-order";
import PurchaseOrderDetail from "layouts/accounting-form/appendix-1/purchase-order/detail";
import AllocationSheetSchedule from "layouts/accounting-form/appendix-1/allocation-sheet-schedule/allocation-sheet-schedule";
import AllocationSheetScheduleDetail from "layouts/accounting-form/appendix-1/allocation-sheet-schedule/detail";
import ConsignmentSettlement from "layouts/accounting-form/appendix-1/consignment-settlement/consignment-settlement";
import ConsignmentSettlementDetail from "layouts/accounting-form/appendix-1/consignment-settlement/detail";
import CounterCard from "layouts/accounting-form/appendix-1/counter-card/counter-card";
import CounterCardDetail from "layouts/accounting-form/appendix-1/counter-card/detail";
import CashReceipt from "layouts/accounting-form/appendix-1/cash-receipt/cash-receipt";
import CashReceiptDetail from "layouts/accounting-form/appendix-1/cash-receipt/detail";
import CashVoucher from "layouts/accounting-form/appendix-1/cash-voucher/cash-voucher";
import CashVoucherDetail from "layouts/accounting-form/appendix-1/cash-voucher/detail";
import CashAdvanceRequest from "layouts/accounting-form/appendix-1/cash-advance-request/cash-advance-request";
import CashAdvanceRequestDetail from "layouts/accounting-form/appendix-1/cash-advance-request/detail";
import AdvancePaymentRequest from "layouts/accounting-form/appendix-1/advance-payment-request/advance-payment-request";
import AdvancePaymentRequestDetail from "layouts/accounting-form/appendix-1/advance-payment-request/detail";
import RequestForPayment from "layouts/accounting-form/appendix-1/request-for-payment/request-for-payment";
import RequestForPaymentDetail from "layouts/accounting-form/appendix-1/request-for-payment/detail";
import PaymentReceipt from "layouts/accounting-form/appendix-1/payment-receipt/payment-receipt";
import PaymentReceiptDetail from "layouts/accounting-form/appendix-1/payment-receipt/detail";
import GoldCurrencyStatement from "layouts/accounting-form/appendix-1/gold-currency-statement/gold-currency-statement";
import GoldCurrencyStatementDetail from "layouts/accounting-form/appendix-1/gold-currency-statement/detail";
import TreasuryInventorySheet from "layouts/accounting-form/appendix-1/treasury-inventory-sheet/treasury-inventory-sheet";
import TreasuryInventorySheetDetail from "layouts/accounting-form/appendix-1/treasury-inventory-sheet/detail";
import ForeignCurrencyGoldCashCountReport from "layouts/accounting-form/appendix-1/foreign-currency-gold-cash-count-report/foreign-currency-gold-cash-count-report";
import ForeignCurrencyGoldCashCountReportDetail from "layouts/accounting-form/appendix-1/foreign-currency-gold-cash-count-report/detail";
import ExpenseReport from "layouts/accounting-form/appendix-1/expense-report/expense-report";
import ExpenseReportDetail from "layouts/accounting-form/appendix-1/expense-report/detail";
import AssetHandoverRecord from "layouts/accounting-form/appendix-1/asset-handover-record/asset-handover-record";
import AssetHandoverRecordDetail from "layouts/accounting-form/appendix-1/asset-handover-record/detail";
import FixedAssetLiquidation from "layouts/accounting-form/appendix-1/fixed-asset-liquidation/fixed-asset-liquidation";
import FixedAssetLiquidationDetail from "layouts/accounting-form/appendix-1/fixed-asset-liquidation/detail";
import HandoverRecordRufAssets from "layouts/accounting-form/appendix-1/handover-record-ruf-assets/handover-record-ruf-assets";
import HandoverRecordRufAssetsDetail from "layouts/accounting-form/appendix-1/handover-record-ruf-assets/detail";
import FixedAssetRevaluationReport from "layouts/accounting-form/appendix-1/fixed-asset-revaluation-report/fixed-asset-revaluation-report";
import SummaryReportFixedAssetInventory from "layouts/accounting-form/appendix-1/summary-report-fixed-asset-inventory/summary-report-fixed-asset-inventory";
import FixedAssetsDepreciationSchedule from "layouts/accounting-form/appendix-1/fixed-assets-depreciation-schedule/fixed-assets-depreciation-schedule";
import FixedAssetsDepreciationScheduleDetail from "layouts/accounting-form/appendix-1/fixed-assets-depreciation-schedule/detail";
import FixedAssetsInventorySummary from "layouts/accounting-form/appendix-1/fixed-assets-inventory-summary/fixed-assets-inventory-summary";
import FixedAssetsInventorySummaryDetail from "layouts/accounting-form/appendix-1/fixed-assets-inventory-summary/detail";
import FixedAssetRevaluation from "layouts/accounting-form/appendix-1/fixed-asset-revaluation/fixed-asset-revaluation";
import FixedAssetRevaluationDetail from "layouts/accounting-form/appendix-1/fixed-asset-revaluation/detail";
import GeneralJournalLedger from "layouts/accounting-form/appendix-2/general-journal-ledger/general-journal-ledger";
import GeneralJournalLedgerDetail from "layouts/accounting-form/appendix-2/general-journal-ledger/detail";
import AccountingVouchers from "layouts/accounting-form/appendix-2/accounting-vouchers/accounting-vouchers";
import AccountingVouchersDetail from "layouts/accounting-form/appendix-2/accounting-vouchers/detail";
import AccountingDocumentRegister from "layouts/accounting-form/appendix-2/accounting-document-register/accounting-document-register";
import AccountingDocumentRegisterDetail from "layouts/accounting-form/appendix-2/accounting-document-register/detail";
import SubsidiaryLedgerS02c1 from "layouts/accounting-form/appendix-2/subsidiary-ledger/subsidiary-ledger";
import SubsidiaryLedgerS02c1Detail from "layouts/accounting-form/appendix-2/subsidiary-ledger/detail/index";
import GeneralLedgerS02c2 from "layouts/accounting-form/appendix-2/general-ledger-s02c2/general-ledger";
import GeneralLedgerS02c2Detail from "layouts/accounting-form/appendix-2/general-ledger-s02c2/detail/index";
import JournalEntries from "layouts/accounting-form/appendix-2/journal-entries/journal-entries";
import JournalEntriesDetail from "layouts/accounting-form/appendix-2/journal-entries/detail/index";
import CashReceiptsJournal from "layouts/accounting-form/appendix-2/cash-receipts-journal/cash-receipts-journal";
import CashReceiptsJournalDetail from "layouts/accounting-form/appendix-2/cash-receipts-journal/detail/index";
import CashBook from "layouts/accounting-form/appendix-2/cash-book/cash-book";
import CashBookDetail from "layouts/accounting-form/appendix-2/cash-book/detail/index";
import PurchasesJournal from "layouts/accounting-form/appendix-2/purchases-journal/purchases-journal";
import PurchasesJournalDetail from "layouts/accounting-form/appendix-2/purchases-journal/detail/index";
import SalesJournal from "layouts/accounting-form/appendix-2/sales-journal/sales-journal";
import SalesJournalDetail from "layouts/accounting-form/appendix-2/sales-journal/detail/index";
import LedgerJournal from "layouts/accounting-form/appendix-2/ledger-journal/ledger-journal";
import LedgerJournalDetail from "layouts/accounting-form/appendix-2/ledger-journal/detail";
import TrialBalance from "layouts/accounting-form/appendix-2/trial-balance/trial-balance";
import AccountingTable1 from "layouts/accounting-form/appendix-2/accounting-table-1/accounting-table-1";
import JournalVoucherSystemLedger from "layouts/accounting-form/appendix-2/journal-voucher-system-ledger/journal-voucher-system-ledger";
import JournalVoucher9 from "layouts/accounting-form/appendix-2/journal-voucher-9/journal-voucher-9";
import JournalVoucher9Detail from "layouts/accounting-form/appendix-2/journal-voucher-9/detail/index";
import JournalVoucher10 from "layouts/accounting-form/appendix-2/journal-voucher-10/journal-voucher-10";
import JournalVoucher10Detail from "layouts/accounting-form/appendix-2/journal-voucher-10/detail/index";
import JournalVoucher8 from "layouts/accounting-form/appendix-2/journal-voucher-8/journal-voucher-8";
import JournalVoucher8Detail from "layouts/accounting-form/appendix-2/journal-voucher-8/detail";
import JournalVoucher7 from "layouts/accounting-form/appendix-2/journal-voucher-7/journal-voucher-7";
import JournalVoucher7Detail from "layouts/accounting-form/appendix-2/journal-voucher-7/detail/index";
import JournalVoucher6 from "layouts/accounting-form/appendix-2/journal-voucher-6/journal-voucher-6";
import JournalVoucher6Detail from "layouts/accounting-form/appendix-2/journal-voucher-6/detail/index";
import JournalVoucher5 from "layouts/accounting-form/appendix-2/journal-voucher-5/journal-voucher-5";
import JournalVoucher5Detail from "layouts/accounting-form/appendix-2/journal-voucher-5/detail/index";
import JournalVoucher4 from "layouts/accounting-form/appendix-2/journal-voucher-4/journal-voucher-4";
import JournalVoucher4Detail from "layouts/accounting-form/appendix-2/journal-voucher-4/detail/index";
import JournalVoucher3 from "layouts/accounting-form/appendix-2/journal-voucher-3/journal-voucher-3";
import JournalVoucher3Detail from "layouts/accounting-form/appendix-2/journal-voucher-3/detail/index";
import JournalVoucher2 from "layouts/accounting-form/appendix-2/journal-voucher-2/journal-voucher-2";
import JournalVoucher2Detail from "layouts/accounting-form/appendix-2/journal-voucher-2/detail/index";
import JournalVoucher1 from "layouts/accounting-form/appendix-2/journal-voucher-1/journal-voucher-1";
import JournalVoucher1Detail from "layouts/accounting-form/appendix-2/journal-voucher-1/detail/index";
import AccountingTable1Detail from "layouts/accounting-form/appendix-2/accounting-table-1/detail/index";
import AccountingTable2 from "layouts/accounting-form/appendix-2/accounting-table-2/accounting-table-2";
import AccountingTable2Detail from "layouts/accounting-form/appendix-2/accounting-table-2/detail/index";
import AccountingTable3 from "layouts/accounting-form/appendix-2/accounting-table-3/accounting-table-3";
import AccountingTable4 from "layouts/accounting-form/appendix-2/accounting-table-4/accounting-table-4";
import AccountingTable4Detail from "layouts/accounting-form/appendix-2/accounting-table-4/detail/index";
import AccountingTable5 from "layouts/accounting-form/appendix-2/accounting-table-5/accounting-table-5";
import AccountingTable5Detail from "layouts/accounting-form/appendix-2/accounting-table-5/detail/index";
import AccountingTable6 from "layouts/accounting-form/appendix-2/accounting-table-6/accounting-table-6";
import AccountingTable6Detail from "layouts/accounting-form/appendix-2/accounting-table-6/detail/index";
import AccountingTable7 from "layouts/accounting-form/appendix-2/accounting-table-7/accounting-table-7";
import AccountingTable8 from "layouts/accounting-form/appendix-2/accounting-table-8/accounting-table-8";
import AccountingTable9 from "layouts/accounting-form/appendix-2/accounting-table-9/accounting-table-9";
import AccountingTable10 from "layouts/accounting-form/appendix-2/accounting-table-10/accounting-table-10";
import AccountingTable10Detail from "layouts/accounting-form/appendix-2/accounting-table-10/detail/index";
import CashLedger from "layouts/accounting-form/appendix-2/cash-ledger/cash-ledger";
import AssetCard from "layouts/accounting-form/appendix-2/asset-card/asset-card";
import AssetCardDetail from "layouts/accounting-form/appendix-2/asset-card/detail";
import FixedAssetsRegister from "layouts/accounting-form/appendix-2/fixed-assets-register/fixed-assets-register";
import FixedAssetsRegisterDetail from "layouts/accounting-form/appendix-2/fixed-assets-register/detail";
import EquipmentLedger from "layouts/accounting-form/appendix-2/equipment-ledger/equipment-ledger";
import EquipmentLedgerDetail from "layouts/accounting-form/appendix-2/equipment-ledger/detail";
import BinCard from "layouts/accounting-form/appendix-2/bin-card/bin-card";
import BinCardDetail from "layouts/accounting-form/appendix-2/bin-card/detail";
import SummaryOfDetailed from "layouts/accounting-form/appendix-2/summary-of-detailed/summary-of-detailed";
import SummaryOfDetailedDetail from "layouts/accounting-form/appendix-2/summary-of-detailed/detail";
import DetailedInventoryLedger from "layouts/accounting-form/appendix-2/detailed-inventory-ledger/detailed-inventory-ledger";
import DetailedInventoryLedgerDetail from "layouts/accounting-form/appendix-2/detailed-inventory-ledger/detail";
import DemandDeposit from "layouts/accounting-form/appendix-2/demand-deposit/demand-deposit";
import DemandDepositDetail from "layouts/accounting-form/appendix-2/demand-deposit/detail";
import PettyCashBook from "layouts/accounting-form/appendix-2/petty-cash-book/petty-cash-book";
import PettyCashBookDetail from "layouts/accounting-form/appendix-2/petty-cash-book/detail";
import CustomerPaymentDetailsLedger from "layouts/accounting-form/appendix-2/customer-payment-details-ledger/customer-payment-details-ledger";
import CustomerPaymentDetailsLedgerDetail from "layouts/accounting-form/appendix-2/customer-payment-details-ledger/detail";
import SubsidiaryLedgerFcPayments from "layouts/accounting-form/appendix-2/subsidiary-ledger-fc-payments/subsidiary-ledger-fc-payments";
import SubsidiaryLedgerFcPaymentsDetail from "layouts/accounting-form/appendix-2/subsidiary-ledger-fc-payments/detail";
import ForeignCurrencyPaymentLedger from "layouts/accounting-form/appendix-2/foreign-currency-payment-ledger/foreign-currency-payment-ledger";
import ForeignCurrencyPaymentLedgerDetail from "layouts/accounting-form/appendix-2/foreign-currency-payment-ledger/detail";
import LoanDetailLedger from "layouts/accounting-form/appendix-2/loan-detail-ledger/loan-detail-ledger";
import LoanDetailLedgerDetail from "layouts/accounting-form/appendix-2/loan-detail-ledger/detail";
import SalesDetailedLedger from "layouts/accounting-form/appendix-2/sales-detailed-ledger/sales-detailed-ledger";
import SalesDetailedLedgerDetail from "layouts/accounting-form/appendix-2/sales-detailed-ledger/detail";
import CostLedger from "layouts/accounting-form/appendix-2/cost-ledger/cost-ledger";
import CostLedgerDetail from "layouts/accounting-form/appendix-2/cost-ledger/detail";
import CostEstimateSheet from "layouts/accounting-form/appendix-2/cost-estimate-sheet/cost-estimate-sheet";
import CostEstimateSheetDetail from "layouts/accounting-form/appendix-2/cost-estimate-sheet/detail";
import SubsidiaryLedgers from "layouts/accounting-form/appendix-2/subsidiary-ledgers/subsidiary-ledgers";
import SubsidiaryLedgersDetail from "layouts/accounting-form/appendix-2/subsidiary-ledgers/detail";
import JointVentureInvestmentDetailedRecord from "layouts/accounting-form/appendix-2/joint-venture-investment-detailed-record/joint-venture-investment-detailed-record";
import JointVentureInvestmentDetailedRecordDetail from "layouts/accounting-form/appendix-2/joint-venture-investment-detailed-record/detail";
import InvestmentJointVentureDifferentialAllocationRecord from "layouts/accounting-form/appendix-2/investment-joint-venture-differential-allocation-record/investment-joint-venture-differential-allocation-record";
import InvestmentJointVentureDifferentialAllocationRecordDetail from "layouts/accounting-form/appendix-2/investment-joint-venture-differential-allocation-record/detail";
import SaInvestmentDetailedRecord from "layouts/accounting-form/appendix-2/sa-investment-detailed-record/sa-investment-detailed-record";
import SaInvestmentDetailedRecordDetail from "layouts/accounting-form/appendix-2/sa-investment-detailed-record/detail";
import InvestmentDifferenceAllocationRegister from "layouts/accounting-form/appendix-2/investment-difference-allocation-register/investment-difference-allocation-register";
import InvestmentDifferenceAllocationRegisterDetail from "layouts/accounting-form/appendix-2/investment-difference-allocation-register/detail";
import StockLedger from "layouts/accounting-form/appendix-2/stock-ledger/stock-ledger";
import StockLedgerDetail from "layouts/accounting-form/appendix-2/stock-ledger/detail";
import RegisterOwnSharesPurchased from "layouts/accounting-form/appendix-2/register-own-shares-purchased/register-own-shares-purchased";
import RegisterOwnSharesPurchasedDetail from "layouts/accounting-form/appendix-2/register-own-shares-purchased/detail";
import SecuritiesPortfolio from "layouts/accounting-form/appendix-2/securities-portfolio/securities-portfolio";
import DetailedLedgerOwnersCapital from "layouts/accounting-form/appendix-2/detailed-ledger-owners-capital/detailed-ledger-owners-capital";
import ProjectCostLedger from "layouts/accounting-form/appendix-2/project-cost-ledger/project-cost-ledger";
import ValueAddedTaxRefund from "layouts/accounting-form/appendix-2/value-added-tax-refund/value-added-tax-refund";
import ValueAddedTaxRefundDetail from "layouts/accounting-form/appendix-2/value-added-tax-refund/detail";
import DetailLedgerVatExemptionReduction from "layouts/accounting-form/appendix-2/detail-ledger-vat-exemption-reduction/detail-ledger-vat-exemption-reduction";
import DetailLedgerVatExemptionReductionDetail from "layouts/accounting-form/appendix-2/detail-ledger-vat-exemption-reduction/detail";
import ValueAddedTaxFilingDetail from "layouts/accounting-form/appendix-2/value-added-tax-filing/detail";
import ValueAddedTaxFiling from "layouts/accounting-form/appendix-2/value-added-tax-filing/value-added-tax-filing";
import ProjectCostLedgerDetail from "layouts/accounting-form/appendix-2/project-cost-ledger/detail";
import DetailedLedgerOwnersCapitalDetail from "layouts/accounting-form/appendix-2/detailed-ledger-owners-capital/detail";
import SecuritiesPortfolioDetail from "layouts/accounting-form/appendix-2/securities-portfolio/detail";
import TrialBalanceDetail from "layouts/accounting-form/appendix-2/trial-balance/detail";
import JournalVoucherSystemLedgerDetail from "layouts/accounting-form/appendix-2/journal-voucher-system-ledger/detail";

const mainRoute = [
  {
    type: "collapse",
    name: "Quản lý công ty",
    key: "manage-companies",
    icon: <Office size="12px" />,
    authoritySideNav: [SUPER_ADMIN, CS],
    collapse: [
      {
        name: "Danh sách công ty",
        key: "companies",
        route: "/manage-companies/companies",
        component: <Companies />,
        authority: [SUPER_ADMIN, CS],
      },
      {
        name: "Tạo công ty",
        key: "companies",
        route: "/manage-companies/companies/create",
        component: <CompanyDetail />,
        hidden: true,
        authority: [SUPER_ADMIN],
      },
      {
        name: "Chi tiết công ty",
        key: "companies",
        route: "/manage-companies/companies/:id",
        component: <CompanyDetail />,
        hidden: true,
        authority: [ADMIN, SUPER_ADMIN, CS],
      },
      {
        name: "Cập nhật công ty",
        key: "companies",
        route: "/manage-companies/companies/:id/edit",
        component: <CompanyDetail />,
        hidden: true,
        authority: [SUPER_ADMIN, ADMIN, CS],
      },

      {
        name: "Danh sách nhân viên",
        key: "employees",
        route: "/manage-employees/employees",
        component: <Employees />,
        authority: [SUPER_ADMIN],
      },
      {
        name: "Tạo nhân viên",
        key: "employees",
        route: "/manage-employees/employees/create",
        component: <EmployeeInfo />,
        hidden: true,
        authority: [SUPER_ADMIN],
      },
      {
        name: "Chi tiết nhân viên",
        key: "employees",
        route: "/manage-employees/employees/:id",
        component: <EmployeeInfo />,
        hidden: true,
        authority: [SUPER_ADMIN],
      },
      {
        name: "Cập nhật nhân viên",
        key: "employees",
        route: "/manage-employees/employees/:id/edit",
        component: <EmployeeInfo />,
        hidden: true,
        authority: [SUPER_ADMIN],
      },
    ],
  },
  {
    type: "collapse",
    name: "Kế toán",
    key: "accounting",
    icon: <CreditCard size="12px" />,
    authoritySideNav: [SUPER_ADMIN, ADMIN, CS],
    collapse: [
      {
        name: "Sổ nhật ký chung",
        key: "general-journal",
        route: "/accounting/general-journal",
        component: <GeneralJournal />,
        authority: [],
      },
      {
        name: "Sổ cái tài khoản",
        key: "general-ledger",
        route: "/accounting/general-ledger",
        component: <AccountingAccounts />,
        authority: [],
      },
      {
        name: "Sổ chi tiết tài khoản kế toán",
        key: "subsidiary-ledger",
        route: "/accounting/subsidiary-ledger",
        component: <AccountingSubsidiaryLedger />,
        authority: [],
      },
    ],
  },
  {
    type: "collapse",
    name: "Công ty của tôi",
    key: "my-company",
    icon: <Shop size="12px" />,
    authoritySideNav: [ADMIN],
    collapse: [
      {
        name: "Chi tiết công ty",
        key: "company",
        route: `/my-company/company/:id`,
        component: <CompanyDetail />,
        authority: [ADMIN],
      },
    ],
  },
  {
    type: "collapse",
    name: "Hóa đơn",
    key: "bills",
    icon: <Basket size="12px" />,
    authoritySideNav: [ADMIN, USER],
    collapse: [
      {
        name: "Hóa đơn đầu ra",
        key: "billsOut",
        route: "/manage-bills/billsOut",
        component: <BillsOut />,
        authority: [ADMIN, USER],
      },
      {
        name: "Tạo hóa đơn",
        key: "billsOut",
        route: "/manage-bills/billsOut/create",
        component: <BillOutDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Chi tiết hóa đơn",
        key: "billsOut",
        route: "/manage-bills/billsOut/:id",
        component: <BillOutDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Chỉnh sửa hóa đơn",
        key: "billsOut",
        route: "/manage-bills/billsOut/:id/edit",
        component: <BillOutDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Hóa đơn đầu vào",
        key: "billsIn",
        route: "/manage-bills/billsIn",
        component: <BillsIn />,
        authority: [ADMIN, USER],
      },
      {
        name: "Tạo hóa đơn",
        key: "billsIn",
        route: "/manage-bills/billsIn/create",
        component: <BillInDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Chi tiết hóa đơn",
        key: "billsIn",
        route: "/manage-bills/billsIn/:id",
        component: <BillInDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Chỉnh sửa hóa đơn",
        key: "billsIn",
        route: "/manage-bills/billsIn/:id/edit",
        component: <BillInDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Quản lý cuốn hóa đơn",
        key: "invoice",
        route: "/invoice-books/invoice",
        component: <InvoiceBooks />,
        authority: [ADMIN, USER],
      },
      {
        name: "Tạo cuốn hóa đơn mới",
        key: "invoice",
        route: "/invoice-books/invoice/create",
        component: <InvoiceDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Chi tiết cuốn hóa đơn",
        key: "invoice",
        route: "/invoice-books/invoice/:id",
        component: <InvoiceDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
      {
        name: "Edit cuốn hóa đơn",
        key: "invoice",
        route: "/invoice-books/invoice/:id/edit",
        component: <InvoiceDetail />,
        hidden: true,
        authority: [ADMIN, USER],
      },
    ],
  },
  {
    type: "collapse",
    name: "Kê khai",
    key: "declarations",
    icon: <Document size="12px" />,
    authoritySideNav: [],
    collapse: [
      {
        type: "collapse",
        name: "Thuế giá trị gia tăng",
        key: "tax-value",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế GTGT (01/GTGT)(TT80/2021)",
            key: "vat-01-TT80-2021",
            route: `/declarations/tax-value/vat-01-TT80-2021`,
            component: <TaxValue01 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế giá trị gia tăng (02/GTGT)(TT80/2021)",
            key: "vat-02-TT80-2021",
            component: <TaxValue02 />,
            authority: [],
            route: `/declarations/tax-value/vat-02-TT80-2021`,
          },
          {
            name: "Tờ khai GTGT trực tiếp trên GTGT (03/GTGT)(TT80/2021)",
            key: "vat-03-TT80-2021",
            component: <TaxValue03 />,
            authority: [],
            route: `/declarations/tax-value/vat-03-TT80-2021`,
          },
          {
            name: "Tờ khai thuế GTGT (04/GTGT)(TT80/2021)",
            key: "vat-04-TT80-2021",
            component: <TaxValue04 />,
            authority: [],
            route: `/declarations/tax-value/vat-04-TT80-2021`,
          },
          {
            name: "Tờ khai thuế GTGT KD ngoại tỉnh (05/GTGT)(TT80/2021)",
            key: "vat-05-TT80-2021",
            component: <TaxValue05 />,
            authority: [],
            route: `/declarations/tax-value/vat-05-TT80-2021`,
          },
          {
            name: "Kê khai thông tin DAĐT chô TK 02/GTGT và 01/HT",
            key: "vat-DADT-02GTGT-01HT",
            component: <TaxValue06 />,
            authority: [],
            route: `/declarations/tax-value/vat-DADT-02GTGT-01HT`,
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế thu nhập doanh nghiệp",
        key: "corporate-income-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai TNDN cho chuyển nhượng BĐS (02/TNDN)(TT80/2021)",
            key: "cit-02-TNDN-TT80-2021",
            route: `/declarations/corporate-income-tax/cit-02-TNDN-TT80-2021`,
            component: <CorporateIncomeTax02 />,
            authority: [],
          },
          {
            name: "Tờ khai quyết toán TNDN (03/TNDN)(TT80/2021)",
            key: "cit-03-TNDN-TT80-2021",
            route: `/declarations/corporate-income-tax/cit-03-TNDN-TT80-2021`,
            component: <CorporateIncomeTax03 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế TNDN (04/TNDN)(TT80/2021)",
            key: "cit-04-TNDN-TT80-2021",
            route: `/declarations/corporate-income-tax/cit-04-TNDN-TT80-2021`,
            component: <CorporateIncomeTax04 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế TNDN (05/TNDN)(TT80/2021)",
            key: "cit-05-TNDN-TT80-2021",
            route: `/declarations/corporate-income-tax/cit-05-TNDN-TT80-2021`,
            component: <CorporateIncomeTax05 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế TNDN (06/TNDN)(TT80/2021)",
            key: "cit-06-TNDN-TT80-2021",
            route: `/declarations/corporate-income-tax/cit-06-TNDN-TT80-2021`,
            component: <CorporateIncomeTax06 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế Thu Nhập Cá Nhân",
        key: "tax-personal",
        authority: [],
        collapse: [
          {
            name: "01/XSBHĐC Tờ khai cho công ty XS, BH, bán hàng đa cấp (TT40/2021)",
            key: "1",
            component: <TaxPersonal01 />,
            authority: [],
            route: "/declarations/tax-personal/1",
          },
          {
            name: "02/KK-TNCN Tờ khai cho cá nhân khai trực tiếp (TT80/2021) ",
            key: "2",
            component: <TaxPersonal02 />,
            authority: [],
            route: "/declarations/tax-personal/2",
          },
          {
            name: "04/CNV-TNCN Tờ khai cho cá nhân chuyển nhượng vốn (TT80/2021)",
            key: "3",
            component: <TaxPersonal03 />,
            authority: [],
            route: "/declarations/tax-personal/3",
          },
          {
            name: "04/DTV-TNCN Tờ khai cho cá nhân đầu tư vốn (TT80/2021)",
            key: "4",
            component: <TaxPersonal04 />,
            authority: [],
            route: "/declarations/tax-personal/4",
          },
          {
            name: "04/NNG-TNCN Tờ khai cho cá nhân trúng thưởng từ nước ngoài (TT80/2021)",
            key: "5",
            component: <TaxPersonal05 />,
            authority: [],
            route: "/declarations/tax-personal/5",
          },
          {
            name: "04/TKQT-TNCN Tờ khai cho cá nhân thừa kế, quà tặng (TT80/2021)",
            key: "6",
            component: <TaxPersonal06 />,
            authority: [],
            route: "/declarations/tax-personal/6",
          },
          {
            name: "05/KK-TNCN Tờ khai khấu trừ thuế TNCN (TT80/2021)",
            key: "7",
            component: <TaxPersonal07 />,
            authority: [],
            route: "/declarations/tax-personal/7",
          },
          {
            name: "06/TNCN Tờ khai khấu trừ từ CNV, CK,... (TT80/2021)",
            key: "8",
            component: <TaxPersonal08 />,
            authority: [],
            route: "/declarations/tax-personal/8",
          },
          {
            name: "01/TKN-CNKD Tờ khai năm cho xổ số, bảo hiểm, đa cấp (TT40/2021)",
            key: "9",
            component: <TaxPersonal09 />,
            authority: [],
            route: "/declarations/tax-personal/9",
          },
          {
            name: "02/QTT-TNCN Tờ khai quyết toán của cá nhân (TT80/2021)",
            key: "10",
            component: <TaxPersonal10 />,
            authority: [],
            route: "/declarations/tax-personal/10",
          },
          {
            name: "05/QTT-TNCN Tờ khai quyết toán thuế thu nhập cá nhân (TT80/2021)",
            key: "11",
            component: <TaxPersonal11 />,
            authority: [],
            route: "/declarations/tax-personal/11",
          },
          {
            name: "Đăng ký người phụ thuộc giảm trừ gia cảnh",
            key: "12",
            component: <TaxPersonal12 />,
            authority: [],
            route: "/declarations/tax-personal/12",
          },
          {
            name: "20-ĐK-TH-TCT Đăng ký thuế tổng hợp NPT của CN có thu nhập từ TL, TC",
            key: "13",
            component: <TaxPersonal13 />,
            authority: [],
            route: "/declarations/tax-personal/13",
          },
          {
            name: "05-ĐK-TH-TCT Tờ khai đăng ký thuế qua cơ quan chi trả (TT105/2020)",
            key: "14",
            component: <TaxPersonal14 />,
            authority: [],
            route: "/declarations/tax-personal/14",
          },
          {
            name: "Hỗ trợ in Quyết toán thuế cho cá nhân (TT92/2015)",
            key: "15",
            component: <TaxPersonal15 />,
            authority: [],
            route: "/declarations/tax-personal/15",
          },
          {
            name: "In mẫu trang bia hồ sơ quyết toán",
            key: "16",
            component: <TaxPersonal16 />,
            authority: [],
            route: "/declarations/tax-personal/16",
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế nhà thầu",
        key: "foreign-contractor-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế nhà thầu nước ngoài (01/NTNN)(TT80/2021)",
            key: "fct-01-NTNN-TT80-2021",
            route: `/declarations/foreign-contractor-tax/fct-01-NTNN-TT80-2021`,
            component: <Fct01NTNN />,
            authority: [],
          },
          {
            name: "Tờ khai thuế nhà thầu nước ngoài (02/NTNN)(TT80/2021)",
            key: "fct-02-NTNN-TT80-2021",
            route: `/declarations/foreign-contractor-tax/fct-02-NTNN-TT80-2021`,
            component: <Fct02NTNN />,
            authority: [],
          },
          {
            name: "Tờ khai thuế nhà thầu nước ngoài (03/NTNN)(TT80/2021)",
            key: "fct-03-NTNN-TT80-2021",
            route: `/declarations/foreign-contractor-tax/fct-03-NTNN-TT80-2021`,
            component: <Fct03NTNN />,
            authority: [],
          },
          {
            name: "Tờ khai thuế nhà thầu nước ngoài (04/NTNN)(TT80/2021)",
            key: "fct-04-NTNN-TT80-2021",
            route: `/declarations/foreign-contractor-tax/fct-04-NTNN-TT80-2021`,
            component: <Fct04NTNN />,
            authority: [],
          },
          {
            name: "Tờ khai thuế TNDN đối với hãng hàng không nước ngoài (01/HKNN)",
            key: "fct-01-HKNN",
            route: `/declarations/foreign-contractor-tax/fct-01-HKNN`,
            component: <Fct01HKNN />,
            authority: [],
          },
          {
            name: "Tờ khai QT thuế TNDN đối với hãng vận tái nước ngoài (01/VTNN)",
            key: "fct-01-VTNN",
            route: `/declarations/foreign-contractor-tax/fct-01-VTNN`,
            component: <Fct01VTNN />,
            authority: [],
          },
          {
            name: "Tờ khai thuế TNDN đối với tổ chức nhận TBH nước ngoài (01/TBH)",
            key: "fct-01-TBH",
            route: `/declarations/foreign-contractor-tax/fct-01-TBH`,
            component: <Fct01TBH />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế tài nguyên",
        key: "natural-resource-consumption-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế tài nguyên (01/TAIN)(TT80/2021)",
            key: "nrct-01-TAIN-TT80-2021",
            route: `/declarations/natural-resource-consumption-tax/nrct-01-TAIN-TT80-2021`,
            component: <ResourceTax01 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế tài nguyên (02/TAIN)(TT80/2021)",
            key: "nrct-02-TAIN-TT80-2021",
            route: `/declarations/natural-resource-consumption-tax/nrct-02-TAIN-TT80-2021`,
            component: <ResourceTax02 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế tiêu thụ đặc biệt",
        key: "excise-duty-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "01/TTĐB Tờ khai thuế TTĐB (TT80/2021)",
            key: "edt-01-TTDB-TT80-2021",
            route: `/declarations/excise-duty-tax/edt-01-TTDB-TT80-2021`,
            component: <ConsumptionTax01 />,
            authority: [],
          },
          {
            name: "02/TTĐB Tờ khai thuế TTĐB (TT80/2021)",
            key: "edt-02-TTDB-TT80-2021",
            route: `/declarations/excise-duty-tax/edt-02-TTDB-TT80-2021`,
            component: <ConsumptionTax02 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Báo cáo tài chính",
        key: "finance-report",
        authority: [ADMIN],
        collapse: [
          {
            name: "Bảng cân đối kế toán",
            key: "balance-sheet",
            route: `/declarations/finance-report/balance-sheet`,
            component: <BalanceSheet />,
            authority: [],
          },
          {
            name: "Tạo bảng cân đối",
            key: "balance-sheet",
            route: `/declarations/finance-report/balance-sheet/create`,
            component: <BalanceSheetDetail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Chi tiết bảng cân đối",
            key: "balance-sheet",
            route: `/declarations/finance-report/balance-sheet/:id`,
            component: <BalanceSheetDetail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Cập nhật bảng cân đối",
            key: "balance-sheet",
            route: `/declarations/finance-report/balance-sheet/edit`,
            component: <BalanceSheetDetail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm (TT200/2014/TT-BTC)",
            key: "B01-DN-TT200-2014-TT-BTC",
            route: `/declarations/finance-report/B01-DN-TT200-2014-TT-BTC`,
            component: <FinancialReport01 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm hợp nhất (TT202/2014/TT-BTC)",
            key: "B01-DN-HN-TT202-2014-TT-BTC",
            route: `/declarations/finance-report/B01-DN-HN-TT202-2014-TT-BTC`,
            component: <FinancialReport02 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ đầy đủ (TT200/2014/TT-BTC)",
            key: "B01a-DN-TT200-2014-TT-BTC",
            route: `/declarations/finance-report/B01a-DN-TT200-2014-TT-BTC`,
            component: <FinancialReport03 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ đầy đủ hợp nhất (TT200/2014/TT-BTC)",
            key: "B01a-DN-HN-TT200-2014-TT-BTC",
            route: `/declarations/finance-report/B01a-DN-HN-TT200-2014-TT-BTC`,
            component: <FinancialReport04 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ tóm lược (TT200/2014/TT-BTC)",
            key: "B01b-DN-TT200-2014-TT-BTC",
            route: `/declarations/finance-report/B01b-DN-TT200-2014-TT-BTC`,
            component: <FinancialReport05 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ tóm lược hợp nhất (TT200/2014/TT-BTC)",
            key: "B01b-DN-HN-TT200-2014-TT-BTC",
            route: `/declarations/finance-report/B01b-DN-HN-TT200-2014-TT-BTC`,
            component: <FinancialReport06 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm (TT49/2014/TT-NHNN)",
            key: "BCDKT01-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKT01-TT49-2014-TT-NHNN`,
            component: <FinancialReport07 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm hợp nhất (TT49/2014/TT-NHNN)",
            key: "BCDKT02-HN-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKT02-HN-TT49-2014-TT-NHNN`,
            component: <FinancialReport08 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ đầy đủ (TT49/2014-NHNN)",
            key: "BCDKTGND01-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKTGND01-TT49-2014-TT-NHNN`,
            component: <FinancialReport09 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ đầy đủ hợp nhất (TT49/2014-NHNN)",
            key: "BCDKTGND02-HN-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKTGND02-HN-TT49-2014-TT-NHNN`,
            component: <FinancialReport10 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ tóm lược (TT49/2014-NHNN)",
            key: "BCDKTGND-TL-01-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKTGND-TL-01-TT49-2014-TT-NHNN`,
            component: <FinancialReport11 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ tóm lược hợp nhất (TT49/2014-NHNN)",
            key: "BCDKTGND-TL-02-HN-TT49-2014-TT-NHNN",
            route: `/declarations/finance-report/BCDKTGND-TL-02-HN-TT49-2014-TT-NHNN`,
            component: <FinancialReport12 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính (B01a-DNN)(TT133/2016/TT-BTC)",
            key: "BBCTC01-B01a-DNN-TT133-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01a-DNN-TT133-2016-TT-BTC`,
            component: <FinancialReport13 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính (B01b-DNN)(TT133/2016/TT-BTC)",
            key: "BBCTC01-B01b-DNN-TT133-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01b-DNN-TT133-2016-TT-BTC`,
            component: <FinancialReport14 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính (B01-DNNKLT)(TT133/2016/TT-BTC)",
            key: "BBCTC01-B01-DNNKLT-TT133-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-DNNKLT-TT133-2016-TT-BTC`,
            component: <FinancialReport15 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính (B01-DNSN)(TT133/2016/TT-BTC)",
            key: "BBCTC01-B01-DNSN-TT133-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-DNSN-TT133-2016-TT-BTC`,
            component: <FinancialReport16 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm (B01-CTCK)(TT334/2016/TT-BTC)",
            key: "BBCTC01-B01-CTCK-TT334-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-CTCK-TT334-2016-TT-BTC`,
            component: <FinancialReport17 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm hợp nhất (B01-CTCK/HN)(TT334/2016/TT-BTC)",
            key: "BBCTC01-B01-CTCK-HN-TT334-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-CTCK-HN-TT334-2016-TT-BTC`,
            component: <FinancialReport18 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính giữa niên độ (B01a-CTCK)(TT334/2016/TT-BTC)",
            key: "BBCTC01-B01a-CTCK-TT334-2016-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01a-CTCK-TT334-2016-TT-BTC`,
            component: <FinancialReport19 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm đây đủ (TT107/2017/TT-BTC)",
            key: "BBCTC01-B01-CTCK-TT107-2017-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-CTCK-TT107-2017-TT-BTC`,
            component: <FinancialReport20 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm đơn giản (TT107/2017/TT-BTC)",
            key: "BBCTC01-B05-TT107-2017-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B05-TT107-2017-TT-BTC`,
            component: <FinancialReport21 />,
            authority: [],
          },
          {
            name: "Bộ báo cáo tài chính năm (TT24/2017/TT-BTC)",
            key: "BBCTC01-B01-HTX-TT24-2017-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01-HTX-TT24-2017-TT-BTC`,
            component: <FinancialReport22 />,
            authority: [],
          },
          {
            name: "Bộ BCTC năm (TT24/2017/TT-BTC)(BCTHTC-B01a-TT133/2016/TT-BTC)",
            key: "BBCTC01-B01a-DNN-TT133-TT24-2016-2017-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01a-DNN-TT133-TT24-2016-2017-TT-BTC`,
            component: <FinancialReport23 />,
            authority: [],
          },
          {
            name: "Bộ BCTC năm (TT24/2017/TT-BTC)(BCTHTC-B01b-TT133/2016/TT-BTC)",
            key: "BBCTC01-B01b-DNN-TT133-TT24-2016-2017-TT-BTC",
            route: `/declarations/finance-report/BBCTC01-B01b-DNN-TT133-TT24-2016-2017-TT-BTC`,
            component: <FinancialReport24 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Hóa đơn",
        key: "bill",
        authority: [ADMIN],
        collapse: [
          {
            name: "Thông báo phát hành hóa đơn (TB01/AC)",
            key: "HD01-TB01-AC",
            route: `/declarations/bill/HD01-TB01-AC`,
            component: <Bill01 />,
            authority: [],
          },
          {
            name: "Báo cáo tình hình nhận in hóa đơn (BC01/AC)",
            key: "HD01-BC01-AC",
            route: `/declarations/bill/HD01-BC01-AC`,
            component: <BillBc01 />,
            authority: [],
          },
          {
            name: "Báo cáo mất, cháy, hỏng hóa đơn (BC21/AC)",
            key: "HD01-BC21-AC",
            route: `/declarations/bill/HD01-BC21-AC`,
            component: <BillBc21 />,
            authority: [],
          },
          {
            name: "Thông báo kết quả hủy hóa đơn (TB03/AC)",
            key: "HD01-TB03-AC",
            route: `/declarations/bill/HD01-TB03-AC`,
            component: <BillTb03 />,
            authority: [],
          },
          {
            name: "Báo cáo tình hình sử dụng hóa đơn (BC26/AC)",
            key: "HD01-BC26-AC",
            route: `/declarations/bill/HD01-BC26-AC`,
            component: <BillBc26 />,
            authority: [],
          },
          {
            name: "Báo cáo tình hình sử dụng hóa đơn theo số lượng (BC26/AC)",
            key: "HD02-BC26-AC",
            route: `/declarations/bill/HD02-BC26-AC`,
            component: <BillQuantityBc26 />,
            authority: [],
          },
          {
            name: "BKHĐ chưa sử dụng của tổ chức, cá nhân (BK01/AC)",
            key: "HD01-BK01-AC",
            route: `/declarations/bill/HD01-BK01-AC`,
            component: <BillBK01 />,
            authority: [],
          },
          {
            name: "Thông báo điều chính thông tin (TB04/AC)",
            key: "HD01-TB04-AC",
            route: `/declarations/bill/HD01-TB04-AC`,
            component: <BillTB04 />,
            authority: [],
          },
          {
            name: "Bảng kê sử dụng chứng từ khấu trừ thuế TNCN",
            key: "HD01-KTTTNCN",
            route: `/declarations/bill/HD01-KTTTNCN`,
            component: <BillPersionalIncome />,
            authority: [],
          },
          {
            name: "Dữ liệu hóa đơn, chứng từ hàng hóa, dịch vụ bán ra (03/DL-HĐĐT)",
            key: "HD01-03-DL-HDDT",
            route: `/declarations/bill/HD01-03-DL-HDDT`,
            component: <Bill03 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Phí - Lệ phí",
        key: "fee",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai phí bảo vệ môi trường (01/PBVMT)(TT80/2021)",
            key: "PHI01-01-PBVMT-TT80-2021",
            route: `/declarations/fee/PHI01-01-PBVMT-TT80-2021`,
            component: <Fee01 />,
            authority: [],
          },
          {
            name: "Tờ khai QT phí bảo vệ môi trường (02/PBVMT)(TT80/2021)",
            key: "PHI01-02-PBVMT-TT80-2021",
            route: `/declarations/fee/PHI01-02-PBVMT-TT80-2021`,
            component: <Fee02 />,
            authority: [],
          },
          {
            name: "Tờ khai phí (01/PH)",
            key: "PHI01-01-PH",
            route: `/declarations/fee/PHI01-01-PH`,
            component: <Fee03 />,
            authority: [],
          },
          {
            name: "Tờ khai quyết toán phí (02/PH)",
            key: "PHI01-02-PH",
            route: `/declarations/fee/PHI01-02-PH`,
            component: <Fee04 />,
            authority: [],
          },
          {
            name: "Tờ khai lệ phí (01/LP)",
            key: "PHI01-01-LP",
            route: `/declarations/fee/PHI01-01-LP`,
            component: <Fee05 />,
            authority: [],
          },
          {
            name: "Tờ khai phí, lệ phí và các khoản thu khác (01/PHLPNG) (TT80/2021)",
            key: "PHI01-01-PHLPNG-TT80-2021",
            route: `/declarations/fee/PHI01-01-PHLPNG-TT80-2021`,
            component: <Fee06 />,
            authority: [],
          },
          {
            name: "Tờ khai QT phí, lệ phí và các khoán thu khác (02/PHLPNG)(TT80/2021)",
            key: "PHI01-02-PHLPNG-TT80-2021",
            route: `/declarations/fee/PHI01-02-PHLPNG-TT80-2021`,
            component: <Fee07 />,
            authority: [],
          },
          {
            name: "Tờ khai lệ phí môn bài (01/LPMB)(TT80/2021)",
            key: "PHI01-01-LPMB-TT80-2021",
            route: `/declarations/fee/PHI01-01-LPMB-TT80-2021`,
            component: <Fee08 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế bảo vệ môi trường",
        key: "environmental-protection-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế bảo vệ môi trường (01/TBVMT)(TT80/2021)",
            key: "TBVMT-01-TT80-2021",
            route: `/declarations/environmental-protection-tax/TBVMT-01-TT80-2021`,
            component: <ProtectResourceTax01 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thuế khoán và thuê tài sản",
        key: "presumptive-rental-tax",
        authority: [ADMIN],
        collapse: [
          {
            name: "01/TT5 Tờ khai thuế đối với hoạt động cho thuê tài sản (TT40/2021)",
            key: "TTS-01-TT40-2021",
            route: `/declarations/presumptive-rental-tax/TTS-01-TT40-2021`,
            component: <TaxProperty01 />,
            authority: [],
          },
          {
            name: "01/CNKD Tờ khai cá nhân kinh doanh (TT40/2021)",
            key: "CNKD-01-TT40-2021",
            route: `/declarations/presumptive-rental-tax/CNKD-01-TT40-2021`,
            component: <TaxProperty02 />,
            authority: [],
          },
          {
            name: "01/BC-SDHĐ-CNKD BC SDHĐ dành cho CNKD nộp thuế theo PP khoán",
            key: "CNKD-SDHĐ-BC-01",
            route: `/declarations/presumptive-rental-tax/CNKD-SDHD-BC-01`,
            component: <TaxProperty03 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Tờ khai thủy điện",
        key: "hydropower-declaration",
        authority: [ADMIN],
        collapse: [],
      },
      {
        type: "collapse",
        name: "Tờ khai dầu khí",
        key: "oil-gas",
        authority: [ADMIN],
        collapse: [
          {
            name: "TK TNDN tạm tính đối với dầu khí (01/TNDN-DK)(TT80/2021)",
            key: "TK01-TNDN-DK-01-TT80-2021",
            route: `/declarations/oil-gas/01`,
            component: <OilGas01 />,
            authority: [],
          },
          {
            name: "TK TNDN tạm tính đối với dầu khí (02/TNDN-DK)(TT80/2021)",
            key: "TK01-TNDN-DK-02-TT80-2021",
            route: `/declarations/oil-gas/02`,
            component: <OilGas02 />,
            authority: [],
          },
          {
            name: "TK các khoản thu về hoa hồng DK, tiền đọc và SD tài liệu DK (01/TNS-DK)",
            key: "TK01-TNS-DK-01",
            route: `/declarations/oil-gas/03`,
            component: <OilGas03 />,
            authority: [],
          },
          {
            name: "TK tạm tính tiền lãi dầu, khí nước chủ nhà (01/LNCN-PSC) ",
            key: "TK01-LNCN-PSC-01",
            route: `/declarations/oil-gas/04`,
            component: <OilGas04 />,
            authority: [],
          },
          {
            name: "TK quyết toán tiền lãi dầu, khí nước chủ nhà (02/LNCN-PSC)  ",
            key: "TK01-LNCN-PSC-02",
            route: `/declarations/oil-gas/05`,
            component: <OilGas05 />,
            authority: [],
          },
          {
            name: "TK tạm tính tiền lãi dầu, khí nước chủ nhà (01/LNCN-VSP) ",
            key: "TK01-LNCN-VSP-01",
            route: `/declarations/oil-gas/06`,
            component: <OilGas06 />,
            authority: [],
          },
          {
            name: "TK quyết toán tiền lãi dầu, khí nước chủ nhà (02/LNCN-VSP) ",
            key: "TK01-LNCN-VSP-02",
            route: `/declarations/oil-gas/07`,
            component: <OilGas07 />,
            authority: [],
          },
          {
            name: "TK thuế tạm tính (01/TK-VSP)",
            key: "TK01-TK-VSP-01",
            route: `/declarations/oil-gas/08`,
            component: <OilGas08 />,
            authority: [],
          },
          {
            name: "TK phụ thu tạm tính (01-1/PTHU-VSP)",
            key: "TK01-PTHU-VSP-01-1",
            route: `/declarations/oil-gas/09`,
            component: <OilGas09 />,
            authority: [],
          },
          {
            name: "TK thuế TNDN tạm tính (01-1/TNDN-VSP)",
            key: "TK01-TNDN-VSP-01-1",
            route: `/declarations/oil-gas/10`,
            component: <OilGas10 />,
            authority: [],
          },
          {
            name: "TK quyết toán phụ thu (02/PTHU-VSP)",
            key: "TK01-PTHU-VSP-02",
            route: `/declarations/oil-gas/11`,
            component: <OilGas11 />,
            authority: [],
          },
          {
            name: "TK phụ thu tạm tính (01/PTHU-DK)",
            key: "TK01-PTHU-DK-01",
            route: `/declarations/oil-gas/12`,
            component: <OilGas12 />,
            authority: [],
          },
          {
            name: "TK Quyết toán phụ thu (02/PTHU-DK)",
            key: "TK01-PTHU-DK-02",
            route: `/declarations/oil-gas/13`,
            component: <OilGas13 />,
            authority: [],
          },
          {
            name: "TK quyết toán phụ thu (03/PTHU-DK)",
            key: "TK01-PTHU-DK-03",
            route: `/declarations/oil-gas/14`,
            component: <OilGas14 />,
            authority: [],
          },
          {
            name: "TK Quyết toán thuế TNDN (02/TNDN-VSP)(TT80/2021)",
            key: "TK01-TNDN-VSP-02-TT80-2021",
            route: `/declarations/oil-gas/15`,
            component: <OilGas15 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế thu nhập doanh nghiệp (03/TNDN-DK)(TT80/2021)",
            key: "TK01-TNDN-DK-03-TT80-2021",
            route: `/declarations/oil-gas/16`,
            component: <OilGas16 />,
            authority: [],
          },
          {
            name: "TK thuế TN tạm tính với dầu khí (01/TAIN-DK)(TT80/2021)",
            key: "TK01-TAIN-DK-01-TT80-2021",
            route: `/declarations/oil-gas/17`,
            component: <OilGas17 />,
            authority: [],
          },
          {
            name: "TK quyết toán thuế TN đối với dầu khí (02/TAIN-DK)(TT80/2021)",
            key: "TK01-TAIN-DK-02-TT80-2021",
            route: `/declarations/oil-gas/18`,
            component: <OilGas18 />,
            authority: [],
          },
          {
            name: "TK quyết toán thuế tài nguyên đối với dầu khí (02/TAIN-VSP)(TT80/2021)",
            key: "TK01-TAIN-VSP-02-TT80-2021",
            route: `/declarations/oil-gas/19`,
            component: <OilGas19 />,
            authority: [],
          },
          {
            name: "BC DKSL dầu khí khai thác (01/BCTL-DK)(TT80/2021)",
            key: "TK01-BCTL-DK-01-TT80-2021",
            route: `/declarations/oil-gas/20`,
            component: <OilGas20 />,
            authority: [],
          },
          {
            name: "TK điều chính thuế đặc biệt đối với khí thiên nhiên (01/ĐCĐB-VSP)",
            key: "TK01-ĐCĐB-VSP-01",
            route: `/declarations/oil-gas/21`,
            component: <OilGas21 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Biên lai thu phí, lệ phí",
        key: "fee-receipt",
        authority: [ADMIN],
        collapse: [
          {
            name: "Thông báo phát hành biên lai",
            key: "TBPHBL01",
            route: `/declarations/fee-receipt/TBPHBL01`,
            component: <NotifyOfReceiptIssuance />,
            authority: [],
          },
          {
            name: "Báo cáo tình hình nhận in biên lai thu phí, lệ phí",
            key: "TBPHBL02",
            route: `/declarations/fee-receipt/TBPHBL02`,
            component: <ReceiveReceipt />,
            authority: [],
          },
          {
            name: "Báo cáo mất, cháy, hông biên lai thu phí, lệ phí",
            key: "TBPHBL03",
            route: `/declarations/fee-receipt/TBPHBL03`,
            component: <LostReceipt />,
            authority: [],
          },
          {
            name: "Thông báo kết quả hủy biên lai thu phí, lệ phí",
            key: "TBPHBL04",
            route: `/declarations/fee-receipt/TBPHBL04`,
            component: <CancelReceipt />,
            authority: [],
          },
          {
            name: "Báo cáo tỉnh hình sử dụng biên lai thu phí, lệ phí (BC7/AC)",
            key: "TBPHBL05-BC7-AC",
            route: `/declarations/fee-receipt/TBPHBL05-BC7-AC`,
            component: <ReceiptBC7 />,
            authority: [],
          },
          {
            name: "Thông báo điều chỉnh thông tin (TB04/AC-BLP)",
            key: "TBPHBL06-TB04-AC-BLP",
            route: `/declarations/fee-receipt/TBPHBL06-TB04-AC-BLP`,
            component: <ReiceiptTB04 />,
            authority: [],
          },
          {
            name: "Bảng kê biên lai chưa sử dụng của cơ quan thu phí, lệ phí",
            key: "TBPHBL07",
            route: `/declarations/fee-receipt/TBPHBL07`,
            component: <UnusedReceipt />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Tem rượu",
        key: "wine-stamp",
        authority: [ADMIN],
        collapse: [
          {
            name: "Thông báo kết quả hủy tem rượu mẫu 2",
            key: "TR01-02",
            route: `/declarations/wine-stamp/TR01-02`,
            component: <CancelWineStamps />,
            authority: [],
          },
          {
            name: "Báo cáo mất tem rượu mẫu 3",
            key: "TR02-03",
            route: `/declarations/wine-stamp/TR02-03`,
            component: <LostWineStamps />,
            authority: [],
          },
          {
            name: "Báo sử dụng tem rượu mẫu 6",
            key: "TR03-06",
            route: `/declarations/wine-stamp/TR03-06`,
            component: <UseWineStamps />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Cổ tức, lợi nhuận được chia",
        key: "dividend-profit",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai cổ tức, LNDC cho phần vồn NN (01/CTLNĐC) (TT80/2021)",
            key: "CTLNĐC-01-TT80-2021",
            route: `/declarations/dividend-profit/CTLNDC-01-TT80-2021`,
            component: <CTLNDCTT80 />,
            authority: [],
          },
          {
            name: "TK QT LNST trích lập các quỹ phải nộp NSNN (01/QT-LNCL)(TT80/2021)",
            key: "QT-LNCL-01-TT80-2021",
            route: `/declarations/dividend-profit/QT-LNCL-01-TT80-2021`,
            component: <QTLNCLTT80 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Hoàn thuế",
        key: "tax-refund",
        authority: [ADMIN],
        collapse: [
          {
            name: "Giấy ĐN hoàn trả khoản thu NSNN (01/HT)",
            key: "HT-01",
            route: `/declarations/tax-refund/HT-01`,
            component: <HT />,
            authority: [],
          },
          {
            name: "Giấy ĐN hoàn trả khoản thu NSNN đối với xăng sinh học (01a/DNHT)",
            key: "HT-01",
            route: `/declarations/tax-refund/DNHT`,
            component: <DNHT />,
            authority: [],
          },
          {
            name: "VB đề nghị xử lý số tiền thuế, tiền chậm nộp, tiền phạt nộp thừa (01/ĐNXLNT)",
            key: "DNXLNT-01",
            route: `/declarations/tax-refund/DNXLNT-01`,
            component: <DNXNLT />,
            authority: [],
          },
          {
            name: "VB đề nghị hủy hồ sơ đề nghị hoàn thuế (01/ĐNHUY)",
            key: "DNHUY-01",
            route: `/declarations/tax-refund/DNHUY-01`,
            component: <DNHUY />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Gia hạn nộp thuế",
        key: "tax-payment-extension",
        authority: [ADMIN],
        collapse: [
          {
            name: "Giấy đề nghị gia hạn nộp thuế và tiền thuê đất",
            key: "GHNT-01",
            route: `/declarations/tax-payment-extension/GHNT-01`,
            component: <TaxPaymentExtension01 />,
            authority: [],
          },
          {
            name: "Giấy đề nghị gia hạn nộp thuế và tiền thuê đất (NĐ52)",
            key: "GHNT-01-ND52",
            route: `/declarations/tax-payment-extension/GHNT-01-ND52`,
            component: <TaxPaymentExtensionND52 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Đề nghị miễn tiền chậm nộp",
        key: "request-late-payment",
        authority: [ADMIN],
        collapse: [
          {
            name: "Đề nghị miễn tiền chậm nộp (01/MTCN)",
            key: "MTCN-01",
            route: `/declarations/request-late-payment/MTCN-01`,
            component: <Freeofcharge01 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Nhà cung cấp nước ngoài",
        key: "foreign-supplier",
        authority: [ADMIN],
        collapse: [
          {
            name: "TK thuế đối với hoạt động kinh doanh TMĐT tại VN (03/NCCNN)",
            key: "NCCNN-03",
            route: `/declarations/foreign-supplier/NCCNN-03`,
            component: <ForeignSupplier01 />,
            authority: [],
          },
          {
            name: "Danh sách theo dõi số tiền chuyển cho NCCNN (04/NCCNN)",
            key: "NCCNN-04",
            route: `/declarations/foreign-supplier/NCCNN-04`,
            component: <ForeignSupplier02 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "DS số hiệu TK thanh toán",
        key: "payment-account",
        authority: [ADMIN],
        collapse: [
          {
            name: "Danh sách số hiệu tài khoản thanh toán (NĐ126/2020/NĐ-CP)",
            key: "ND-CP-ND126-2020",
            route: `/declarations/payment-account/ND-CP-ND126-2020`,
            component: <PaymentAccount01 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Đất đai",
        key: "land",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế sử dụng đất nông nghiệp (01/SDDNN)",
            key: "SDDNN-01",
            route: `/declarations/land/SDDNN-01`,
            component: <Land01 />,
            authority: [],
          },
          {
            name: "Tờ khai thuế sử dụng đất nông nghiệp (03/SDDNN)",
            key: "SDDNN-03",
            route: `/declarations/land/SDDNN-03`,
            component: <Land02 />,
            authority: [],
          },
          {
            name: "Tờ khai tiền thuê đất, thuê mặt nước (01/TMĐN)",
            key: "TMDN-01",
            route: `/declarations/land/TMDN-01`,
            component: <Land03 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Tài sản đảm bảo",
        key: "collateral",
        authority: [ADMIN],
        collapse: [
          {
            name: "Tờ khai thuế đối với hoạt động khai thác tài sản bảo đảm (01/KTTSBD)",
            key: "KTTSBD-01",
            route: `/declarations/collateral/KTTSBD-01`,
            component: <Collateral01 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Thương mại điện tử",
        key: "ecommerce",
        authority: [ADMIN],
        collapse: [
          {
            name: "Phiếu tổng hợp TT bán HH, DV trên sàn TMĐT (01/CCTT-TMĐT)",
            key: "CCTT-TMDT-01",
            route: `/declarations/ecommerce/CCTT-TMDT-01`,
            component: <Ecommerce01 />,
            authority: [],
          },
        ],
      },
      {
        type: "collapse",
        name: "Tờ khai chuyển đổi chủ sở hữu, chuyển nhượng vốn",
        key: "OCCT",
        authority: [ADMIN],
        collapse: [
          {
            name: "TK số thu từ cổ phần hóa (01/CPH) (T157/2022)",
            key: "OCCT-01-CPH-T157-2022",
            route: `/declarations/OCCT/OCCT-01-CPH-T157-2022`,
            component: <CapitalTransfer01 />,
            authority: [],
          },
          {
            name: "TK QT số thu từ cổ phần hóa (02/QT-CPH) (TT57/2022)",
            key: "OCCT-02-QT-CPH-TT57-2022",
            route: `/declarations/OCCT/OCCT-02-QT-CPH-TT57-2022`,
            component: <CapitalTransfer02 />,
            authority: [],
          },
          {
            name: "TK số thu từ chuyển nhượng vốn (01/CNV) (T157/2022)",
            key: "OCCT-01-CNV-T157-2022",
            route: `/declarations/OCCT/OCCT-01-CNV-T157-2022`,
            component: <CapitalTransfer03 />,
            authority: [],
          },
          {
            name: "TK QT số thu từ chuyển nhượng vốn (02/QT-CNV) (TT57/2022)",
            key: "OCCT-02-QT-CNV-TT57-2022",
            route: `/declarations/OCCT/OCCT-02-QT-CNV-TT57-2022`,
            component: <CapitalTransfer04 />,
            authority: [],
          },
          {
            name: "TK QT số thu từ hình thức SX, CĐ khác (02/QT-SXCDK) (TT57/2022) ",
            key: "OCCT-02-QT-SXCDK-TT57-2022",
            route: `/declarations/OCCT/OCCT-02-QT-SXCDK-TT57-2022`,
            component: <CapitalTransfer05 />,
            authority: [],
          },
          {
            name: "TK số thu chênh lệch VOSH lớn hơn VĐL (01/CLVCSH-VDL) (TT57/2022)",
            key: "OCCT-01-CLVCSH-VDL-TT57-2022",
            route: `/declarations/OCCT/OCCT-01-CLVCSH-VDL-TT57-2022`,
            component: <CapitalTransfer06 />,
            authority: [],
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Tra cứu",
    key: "research",
    icon: <Cube size="12px" />,
    authoritySideNav: [ADMIN],
    collapse: [
      {
        name: "Danh sách TK kế toán TT99",
        key: "accounting-account",
        route: `/research/accounting-account`,
        component: <AccountingAccounts />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT133",
        key: "accounting-account-tt133",
        route: "/research/accounting-account-tt133",
        component: <AccountingAccountsTT133 />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT132",
        key: "accounting-account-tt132",
        route: "/research/accounting-account-tt132",
        component: <AccountingAccountsTT132 />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT200",
        key: "accounting-account-tt200",
        route: "/research/accounting-account-tt200",
        component: <AccountingAccountsTT200 />,
        authority: [],
      },
      {
        name: "Mã ngành kinh doanh",
        key: "business-code",
        route: `/research/business-code`,
        component: <BusinessCode />,
        authority: [],
      },
    ],
  },
  {
    type: "collapse",
    name: "Cấu hình",
    key: "configuration",
    icon: <SettingsIcon size="12px" />,
    authoritySideNav: [SUPER_ADMIN, CS],
    collapse: [
      {
        name: "Tài khoản kế toán TT99",
        key: "accounting-account",
        route: "/configuration/accounting-account-tt99",
        component: <AccountingAccountsTT99 />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT133",
        key: "accounting-account-tt133",
        route: "/configuration/accounting-account-tt133",
        component: <AccountingAccountsTT133 />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT132",
        key: "accounting-account-tt132",
        route: "/configuration/accounting-account-tt132",
        component: <AccountingAccountsTT132 />,
        authority: [],
      },
      {
        name: "Tài khoản kế toán TT200",
        key: "accounting-account-tt200",
        route: "/configuration/accounting-account-tt200",
        component: <AccountingAccountsTT200 />,
        authority: [],
      },
    ],
  },
  {
    type: "collapse",
    name: "Biểu Mẫu",
    key: "accounting-templates",
    icon: <Document size="12px" />,
    authoritySideNav: [],
    collapse: [
      {
        type: "collapse",
        name: "Phụ Lục I",
        key: "appendix-I",
        authority: [SUPER_ADMIN, ADMIN],
        collapse: [
          {
            name: "Bảng Thanh Toán Tiền Lương",
            key: "payroll-payment-sheet",
            route: `/templates/payroll-payment-sheet`,
            component: <PayrollPaymentSheet />,
            authority: [],
          },
          {
            name: "Bảng lương",
            key: "create-payroll-payment-sheet",
            route: "/templates/payroll-payment-sheet/create",
            component: <PayrollPaymentSheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng lương",
            key: "view-payroll-payment-sheet",
            route: "/templates/payroll-payment-sheet/:id/view",
            component: <PayrollPaymentSheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng lương",
            key: "edit-payroll-payment-sheet",
            route: "/templates/payroll-payment-sheet/:id/edit",
            component: <PayrollPaymentSheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Thưởng",
            key: "bonus-payment-table",
            route: `/templates/bonus-payment-table`,
            component: <BonusPaymentTable />,
            authority: [],
          },
          {
            name: "Bảng thưởng",
            key: "create-bonus-payment-table",
            route: "/templates/bonus-payment-table/create",
            component: <BonusPaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng thưởng",
            key: "view-bonus-payment-table",
            route: "/templates/bonus-payment-table/:id/view",
            component: <BonusPaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng thưởng",
            key: "edit-bonus-payment-table",
            route: "/templates/bonus-payment-table/:id/edit",
            component: <BonusPaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Làm Thêm Giờ",
            key: "overtime-payment-table",
            route: `/templates/overtime-payment-table`,
            component: <OvertimePaymentTable />,
            authority: [],
          },
          {
            name: "Bảng làm thêm giờ",
            key: "create-overtime-payment-table",
            route: "/templates/overtime-payment-table/create",
            component: <OvertimePaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng làm thêm giờ",
            key: "view-overtime-payment-table",
            route: "/templates/overtime-payment-table/:id/view",
            component: <OvertimePaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng làm thêm giờ",
            key: "edit-overtime-payment-table",
            route: "/templates/overtime-payment-table/:id/edit",
            component: <OvertimePaymentTableDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Thuê Ngoài",
            key: "outsourcing-payment-schedule",
            route: `/templates/outsourcing-payment-schedule`,
            component: <OutsourcingPaymentSchedule />,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Thuê Ngoài",
            key: "create-outsourcing-payment-schedule",
            route: "/templates/outsourcing-payment-schedule/create",
            component: <OutsourcingPaymentScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Thuê Ngoài",
            key: "view-outsourcing-payment-schedule",
            route: "/templates/outsourcing-payment-schedule/:id/view",
            component: <OutsourcingPaymentScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Tiền Thuê Ngoài",
            key: "edit-outsourcing-payment-schedule",
            route: "/templates/outsourcing-payment-schedule/:id/edit",
            component: <OutsourcingPaymentScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Hợp Đồng Giao Khoán",
            key: "contract-for-work",
            route: `/templates/contract-for-work`,
            component: <ContractForWork />,
            authority: [],
          },
          {
            name: "Hợp Đồng Giao Khoán",
            key: "create-contract-for-work",
            route: "/templates/contract-for-work/create",
            component: <ContractForWorkDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Hợp Đồng Giao Khoán",
            key: "view-contract-for-work",
            route: "/templates/contract-for-work/:id/view",
            component: <ContractForWorkDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Hợp Đồng Giao Khoán",
            key: "edit-contract-for-work",
            route: "/templates/contract-for-work/:id/edit",
            component: <ContractForWorkDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Thanh Lý (Nghiệm Thu) Hợp Đồng Giao Khoán",
            key: "contract-liquidation-acceptance-minutes",
            route: `/templates/contract-liquidation-acceptance-minutes`,
            component: <ContractLiquidationAcceptanceMinutes />,
            authority: [],
          },
          {
            name: "Biên Bản Thanh Lý HĐ Giao Khoán",
            key: "create-contract-liquidation-acceptance-minutes",
            route: "/templates/contract-liquidation-acceptance-minutes/create",
            component: <ContractLiquidationAcceptanceMinutesDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Thanh Lý HĐ Giao Khoán",
            key: "view-contract-liquidation-acceptance-minutes",
            route: "/templates/contract-liquidation-acceptance-minutes/:id/view",
            component: <ContractLiquidationAcceptanceMinutesDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Thanh Lý HĐ Giao Khoán",
            key: "edit-contract-liquidation-acceptance-minutes",
            route: "/templates/contract-liquidation-acceptance-minutes/:id/edit",
            component: <ContractLiquidationAcceptanceMinutesDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy đề nghị tạm ứng",
            key: "cash-advance-request",
            route: `/templates/cash-advance-request`,
            component: <CashAdvanceRequest />,
            authority: [],
          },
          {
            name: "Giấy đề nghị tạm ứng",
            key: "create-cash-advance-request",
            route: "/templates/cash-advance-request/create",
            component: <CashAdvanceRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy đề nghị tạm ứng",
            key: "view-cash-advance-request",
            route: "/templates/cash-advance-request/:id/view",
            component: <CashAdvanceRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy đề nghị tạm ứng",
            key: "edit-cash-advance-request",
            route: "/templates/cash-advance-request/:id/edit",
            component: <CashAdvanceRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Trích Nộp Các Khoản Theo Lương",
            key: "payroll-deductions-remittance-statement",
            route: `/templates/payroll-deductions-remittance-statement`,
            component: <PayrollDeductionsRemittanceStatement />,
            authority: [],
          },
          {
            name: "Bảng Kê Trích Nộp Các Khoản Theo Lương",
            key: "create-payroll-deductions-remittance-statement",
            route: "/templates/payroll-deductions-remittance-statement/create",
            component: <PayrollDeductionsRemittanceStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Trích Nộp Các Khoản Theo Lương",
            key: "view-payroll-deductions-remittance-statement",
            route: "/templates/payroll-deductions-remittance-statement/:id/view",
            component: <PayrollDeductionsRemittanceStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Trích Nộp Các Khoản Theo Lương",
            key: "edit-payroll-deductions-remittance-statement",
            route: "/templates/payroll-deductions-remittance-statement/:id/edit",
            component: <PayrollDeductionsRemittanceStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Tiền Lương Và Các Khoản Trích Theo Lương",
            key: "payroll-distribution-schedule",
            route: `/templates/payroll-distribution-schedule`,
            component: <PayrollDistributionSchedule />,
            authority: [],
          },
          {
            name: "Bảng Phân Bổ Tiền Lương Và Các Khoản Trích Theo Lương",
            key: "create-payroll-distribution-schedule",
            route: "/templates/payroll-distribution-schedule/create",
            component: <PayrollDistributionScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Tiền Lương Và Các Khoản Trích Theo Lương",
            key: "view-payroll-distribution-schedule",
            route: "/templates/payroll-distribution-schedule/:id/view",
            component: <PayrollDistributionScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Tiền Lương Và Các Khoản Trích Theo Lương",
            key: "edit-payroll-distribution-schedule",
            route: "/templates/payroll-distribution-schedule/:id/edit",
            component: <PayrollDistributionScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Nhập Kho",
            key: "goods-received-note",
            route: `/templates/goods-received-note`,
            component: <GoodsReceivedNote />,
            authority: [],
          },
          {
            name: "Phiếu Nhập Kho",
            key: "create-goods-received-note",
            route: "/templates/goods-received-note/create",
            component: <GoodsReceivedNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Nhập Kho",
            key: "view-goods-received-note",
            route: "/templates/goods-received-note/:id/view",
            component: <GoodsReceivedNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Nhập Kho",
            key: "edit-goods-received-note",
            route: "/templates/goods-received-note/:id/edit",
            component: <GoodsReceivedNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Xuất Kho",
            key: "goods-delivery-note",
            route: `/templates/goods-delivery-note`,
            component: <GoodsDeliveryNote />,
            authority: [],
          },
          {
            name: "Phiếu Xuất Kho",
            key: "create-goods-delivery-note",
            route: "/templates/goods-delivery-note/create",
            component: <GoodsDeliveryNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Xuất Kho",
            key: "view-goods-delivery-note",
            route: "/templates/goods-delivery-note/:id/view",
            component: <GoodsDeliveryNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Xuất Kho",
            key: "edit-goods-delivery-note",
            route: "/templates/goods-delivery-note/:id/edit",
            component: <GoodsDeliveryNoteDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Nghiệm Vật tư, công cụ, sản phẩm, hàng hóa",
            key: "verification-report",
            route: `/templates/verification-report`,
            component: <VerificationReport />,
            authority: [],
          },
          {
            name: "Biên Bản Kiểm Nghiệm Vật tư, công cụ, sản phẩm, hàng hóa",
            key: "create-verification-report",
            route: "/templates/verification-report/create",
            component: <VerificationReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Nghiệm Vật tư, công cụ, sản phẩm, hàng hóa",
            key: "view-verification-report",
            route: "/templates/verification-report/:id/view",
            component: <VerificationReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Nghiệm Vật tư, công cụ, sản phẩm, hàng hóa",
            key: "edit-verification-report",
            route: "/templates/verification-report/:id/edit",
            component: <VerificationReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Chi Tiết Vật Tư Còn Lại Cuối Kỳ",
            key: "materials-stock-report",
            route: `/templates/materials-stock-report`,
            component: <MaterialsStockReport />,
            authority: [],
          },
          {
            name: "Bản Kê Chi Tiết Vật Tư Còn Lại Cuối Kỳ",
            key: "create-materials-stock-report",
            route: "/templates/materials-stock-report/create",
            component: <MaterialsStockReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Chi Tiết Vật Tư Còn Lại Cuối Kỳ",
            key: "view-materials-stock-report",
            route: "/templates/materials-stock-report/:id/view",
            component: <MaterialsStockReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Chi Tiết Vật Tư Còn Lại Cuối Kỳ",
            key: "edit-materials-stock-report",
            route: "/templates/materials-stock-report/:id/edit",
            component: <MaterialsStockReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Vật Tư, Công Cụ, Sản Phẩm, Hàng Hóa",
            key: "inventory-summary-report",
            route: `/templates/inventory-summary-report`,
            component: <InventorySummaryReport />,
            authority: [],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Vật Tư, Công Cụ, Sản Phẩm, Hàng Hóa",
            key: "create-inventory-summary-report",
            route: "/templates/inventory-summary-report/create",
            component: <InventorySummaryReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Vật Tư, Công Cụ, Sản Phẩm, Hàng Hóa",
            key: "view-inventory-summary-report",
            route: "/templates/inventory-summary-report/:id/view",
            component: <InventorySummaryReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Vật Tư, Công Cụ, Sản Phẩm, Hàng Hóa",
            key: "edit-inventory-summary-report",
            route: "/templates/inventory-summary-report/:id/edit",
            component: <InventorySummaryReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Mua Hàng",
            key: "purchase-order",
            route: `/templates/purchase-order`,
            component: <PurchaseOrder />,
            authority: [],
          },
          {
            name: "Bản Kê Mua Hàng",
            key: "create-purchase-order",
            route: "/templates/purchase-order/create",
            component: <PurchaseOrderDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Mua Hàng",
            key: "view-purchase-order",
            route: "/templates/purchase-order/:id/view",
            component: <PurchaseOrderDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bản Kê Mua Hàng",
            key: "edit-purchase-order",
            route: "/templates/purchase-order/:id/edit",
            component: <PurchaseOrderDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Nguyên Liệu, Vật Liệu, Công Cụ, Dụng Cụ",
            key: "allocation-sheet-schedule",
            route: `/templates/allocation-sheet-schedule`,
            component: <AllocationSheetSchedule />,
            authority: [],
          },
          {
            name: "Bảng Phân Bổ Nguyên Liệu, Vật Liệu, Công Cụ, Dụng Cụ",
            key: "create-allocation-sheet-schedule",
            route: "/templates/allocation-sheet-schedule/create",
            component: <AllocationSheetScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Nguyên Liệu, Vật Liệu, Công Cụ, Dụng Cụ",
            key: "view-allocation-sheet-schedule",
            route: "/templates/allocation-sheet-schedule/:id/view",
            component: <AllocationSheetScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Phân Bổ Nguyên Liệu, Vật Liệu, Công Cụ, Dụng Cụ",
            key: "edit-allocation-sheet-schedule",
            route: "/templates/allocation-sheet-schedule/:id/edit",
            component: <AllocationSheetScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Hàng Đại Lý, Ký Gửi",
            key: "consignment-settlement",
            route: `/templates/consignment-settlement`,
            component: <ConsignmentSettlement />,
            authority: [],
          },
          {
            name: "Bảng Thanh Toán Hàng Đại Lý, Ký Gửi",
            key: "create-consignment-settlement",
            route: "/templates/consignment-settlement/create",
            component: <ConsignmentSettlementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Hàng Đại Lý, Ký Gửi",
            key: "view-consignment-settlement",
            route: "/templates/consignment-settlement/:id/view",
            component: <ConsignmentSettlementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Thanh Toán Hàng Đại Lý, Ký Gửi",
            key: "edit-consignment-settlement",
            route: "/templates/consignment-settlement/:id/edit",
            component: <ConsignmentSettlementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Thẻ Quầy Hàng",
            key: "counter-card",
            route: `/templates/counter-card`,
            component: <CounterCard />,
            authority: [],
          },
          {
            name: "Thẻ Quầy Hàng",
            key: "create-counter-card",
            route: "/templates/counter-card/create",
            component: <CounterCardDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Thẻ Quầy Hàng",
            key: "view-counter-card",
            route: "/templates/counter-card/:id/view",
            component: <CounterCardDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Thẻ Quầy Hàng",
            key: "edit-counter-card",
            route: "/templates/counter-card/:id/edit",
            component: <CounterCardDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Thu",
            key: "cash-receipt",
            route: `/templates/cash-receipt`,
            component: <CashReceipt />,
            authority: [],
          },
          {
            name: "Phiếu Thu",
            key: "create-cash-receipt",
            route: "/templates/cash-receipt/create",
            component: <CashReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Thu",
            key: "view-cash-receipt",
            route: "/templates/cash-receipt/:id/view",
            component: <CashReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Thu",
            key: "edit-cash-receipt",
            route: "/templates/cash-receipt/:id/edit",
            component: <CashReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Chi",
            key: "cash-voucher",
            route: `/templates/cash-voucher`,
            component: <CashVoucher />,
            authority: [],
          },
          {
            name: "Phiếu Chi",
            key: "create-cash-voucher",
            route: "/templates/cash-voucher/create",
            component: <CashVoucherDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Chi",
            key: "view-cash-voucher",
            route: "/templates/cash-voucher/:id/view",
            component: <CashVoucherDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Phiếu Chi",
            key: "edit-cash-voucher",
            route: "/templates/cash-voucher/:id/edit",
            component: <CashVoucherDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Thanh Toán Tiền Tạm Ứng",
            key: "advance-payment-request",
            route: `/templates/advance-payment-request`,
            component: <AdvancePaymentRequest />,
            authority: [],
          },
          {
            name: "Giấy Thanh Toán Tiền Tạm Ứng",
            key: "create-advance-payment-request",
            route: "/templates/advance-payment-request/create",
            component: <AdvancePaymentRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Thanh Toán Tiền Tạm Ứng",
            key: "view-advance-payment-request",
            route: "/templates/advance-payment-request/:id/view",
            component: <AdvancePaymentRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Thanh Toán Tiền Tạm Ứng",
            key: "edit-advance-payment-request",
            route: "/templates/advance-payment-request/:id/edit",
            component: <AdvancePaymentRequestDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Đề Nghị Thanh Toán",
            key: "request-for-payment",
            route: `/templates/request-for-payment`,
            component: <RequestForPayment />,
            authority: [],
          },
          {
            name: "Giấy Đề Nghị Thanh Toán",
            key: "create-request-for-payment",
            route: "/templates/request-for-payment/create",
            component: <RequestForPaymentDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Đề Nghị Thanh Toán",
            key: "view-request-for-payment",
            route: "/templates/request-for-payment/:id/view",
            component: <RequestForPaymentDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Giấy Đề Nghị Thanh Toán",
            key: "edit-request-for-payment",
            route: "/templates/request-for-payment/:id/edit",
            component: <RequestForPaymentDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Lai Thu Tiền",
            key: "payment-receipt",
            route: `/templates/payment-receipt`,
            component: <PaymentReceipt />,
            authority: [],
          },
          {
            name: "Biên Lai Thu Tiền",
            key: "create-payment-receipt",
            route: "/templates/payment-receipt/create",
            component: <PaymentReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Lai Thu Tiền",
            key: "view-payment-receipt",
            route: "/templates/payment-receipt/:id/view",
            component: <PaymentReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Lai Thu Tiền",
            key: "edit-payment-receipt",
            route: "/templates/payment-receipt/:id/edit",
            component: <PaymentReceiptDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Vàng Tiền Tệ",
            key: "gold-currency-statement",
            route: `/templates/gold-currency-statement`,
            component: <GoldCurrencyStatement />,
            authority: [],
          },
          {
            name: "Bảng Kê Vàng Tiền Tệ",
            key: "create-gold-currency-statement",
            route: "/templates/gold-currency-statement/create",
            component: <GoldCurrencyStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Vàng Tiền Tệ",
            key: "view-gold-currency-statement",
            route: "/templates/gold-currency-statement/:id/view",
            component: <GoldCurrencyStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Vàng Tiền Tệ",
            key: "edit-gold-currency-statement",
            route: "/templates/gold-currency-statement/:id/edit",
            component: <GoldCurrencyStatementDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kiểm Kê Quỹ Tiền Mặt",
            key: "treasury-inventory-sheet",
            route: `/templates/treasury-inventory-sheet`,
            component: <TreasuryInventorySheet />,
            authority: [],
          },
          {
            name: "Bảng Kiểm Kê Quỹ Tiền Mặt",
            key: "create-treasury-inventory-sheet",
            route: "/templates/treasury-inventory-sheet/create",
            component: <TreasuryInventorySheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kiểm Kê Quỹ Tiền Mặt",
            key: "view-treasury-inventory-sheet",
            route: "/templates/treasury-inventory-sheet/:id/view",
            component: <TreasuryInventorySheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kiểm Kê Quỹ Tiền Mặt",
            key: "edit-treasury-inventory-sheet",
            route: "/templates/treasury-inventory-sheet/:id/edit",
            component: <TreasuryInventorySheetDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Kê Quỹ Vàng Ngoại Tệ",
            key: "foreign-currency-gold-cash-count-report",
            route: `/templates/foreign-currency-gold-cash-count-report`,
            component: <ForeignCurrencyGoldCashCountReport />,
            authority: [],
          },
          {
            name: "Biên Bản Kiểm Kê Quỹ Vàng Ngoại Tệ",
            key: "create-foreign-currency-gold-cash-count-report",
            route: "/templates/foreign-currency-gold-cash-count-report/create",
            component: <ForeignCurrencyGoldCashCountReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Kê Quỹ Vàng Ngoại Tệ",
            key: "view-foreign-currency-gold-cash-count-report",
            route: "/templates/foreign-currency-gold-cash-count-report/:id/view",
            component: <ForeignCurrencyGoldCashCountReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Kiểm Kê Quỹ Vàng Ngoại Tệ",
            key: "edit-foreign-currency-gold-cash-count-report",
            route: "/templates/foreign-currency-gold-cash-count-report/:id/edit",
            component: <ForeignCurrencyGoldCashCountReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Chi Tiền",
            key: "expense-report",
            route: `/templates/expense-report`,
            component: <ExpenseReport />,
            authority: [],
          },
          {
            name: "Bảng Kê Chi Tiền",
            key: "create-expense-report",
            route: "/templates/expense-report/create",
            component: <ExpenseReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Chi Tiền",
            key: "view-expense-report",
            route: "/templates/expense-report/:id/view",
            component: <ExpenseReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Kê Chi Tiền",
            key: "edit-expense-report",
            route: "/templates/expense-report/:id/edit",
            component: <ExpenseReportDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Giao Nhận TSCĐ",
            key: "asset-handover-record",
            route: `/templates/asset-handover-record`,
            component: <AssetHandoverRecord />,
            authority: [],
          },
          {
            name: "Biên Bản Giao Nhận TSCĐ",
            key: "create-asset-handover-record",
            route: "/templates/asset-handover-record/create",
            component: <AssetHandoverRecordDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Giao Nhận TSCĐ",
            key: "view-asset-handover-record",
            route: "/templates/asset-handover-record/:id/view",
            component: <AssetHandoverRecordDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Giao Nhận TSCĐ",
            key: "edit-asset-handover-record",
            route: "/templates/asset-handover-record/:id/edit",
            component: <AssetHandoverRecordDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản thanh lý Tài Sản Cố Định",
            key: "fixed-asset-liquidation",
            route: `/templates/fixed-asset-liquidation`,
            component: <FixedAssetLiquidation />,
            authority: [],
          },
          {
            name: "Biên Bản thanh lý Tài Sản Cố Định",
            key: "create-fixed-asset-liquidation",
            route: "/templates/fixed-asset-liquidation/create",
            component: <FixedAssetLiquidationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản thanh lý Tài Sản Cố Định",
            key: "view-fixed-asset-liquidation",
            route: "/templates/fixed-asset-liquidation/:id/view",
            component: <FixedAssetLiquidationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản thanh lý Tài Sản Cố Định",
            key: "edit-fixed-asset-liquidation",
            route: "/templates/fixed-asset-liquidation/:id/edit",
            component: <FixedAssetLiquidationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Bàn Giao Tài Sản Cố Định Sửa Chữa, Bảo Dưỡng, Nâng Cấp",
            key: "handover-record-ruf-assets",
            route: `/templates/handover-record-ruf-assets`,
            component: <HandoverRecordRufAssets />,
            authority: [],
          },
          {
            name: "Biên Bản Bàn Giao Tài Sản Cố Định Sửa Chữa, Bảo Dưỡng, Nâng Cấp",
            key: "create-handover-record-ruf-assets",
            route: "/templates/handover-record-ruf-assets/create",
            component: <HandoverRecordRufAssetsDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Bàn Giao Tài Sản Cố Định Sửa Chữa, Bảo Dưỡng, Nâng Cấp",
            key: "view-handover-record-ruf-assets",
            route: "/templates/handover-record-ruf-assets/:id/view",
            component: <HandoverRecordRufAssetsDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Bàn Giao Tài Sản Cố Định Sửa Chữa, Bảo Dưỡng, Nâng Cấp",
            key: "edit-handover-record-ruf-assets",
            route: "/templates/handover-record-ruf-assets/:id/edit",
            component: <HandoverRecordRufAssetsDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///////
          {
            name: "Biên Bản Đánh Giá Lại Tài Sản Cố Định",
            key: "fixed-asset-revaluation-report",
            route: `/templates/fixed-asset-revaluation-report`,
            component: <FixedAssetRevaluation />,
            authority: [],
          },
          {
            name: "Biên Bản Đánh Giá Lại TSCĐ - Tạo",
            key: "create-fixed-asset-revaluation",
            route: "/templates/fixed-asset-revaluation/create",
            component: <FixedAssetRevaluationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Đánh Giá Lại TSCĐ - Xem",
            key: "view-fixed-asset-revaluation",
            route: "/templates/fixed-asset-revaluation/:id/view",
            component: <FixedAssetRevaluationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Đánh Giá Lại TSCĐ - Sửa",
            key: "edit-fixed-asset-revaluation",
            route: "/templates/fixed-asset-revaluation/:id/edit",
            component: <FixedAssetRevaluationDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///////
          // {
          //   name: "Biên Bản Tổng Kết Kiểm Kê Tài Sản Cố Định",
          //   key: "summary-report-fixed-asset-inventory",
          //   route: `/templates/summary-report-fixed-asset-inventory`,
          //   component: <SummaryReportFixedAssetInventory />,
          //   authority: [],
          // },
          {
            name: "Bảng Tính Và Phân Bổ Khấu Hao Tài Sản Cố Định",
            key: "fixed-assets-depreciation-schedule",
            route: `/templates/fixed-assets-depreciation-schedule`,
            component: <FixedAssetsDepreciationSchedule />,
            authority: [],
          },
          {
            name: "Bảng Khấu Hao TSCĐ",
            key: "create-fixed-assets-depreciation-schedule",
            route: "/templates/fixed-assets-depreciation-schedule/create",
            component: <FixedAssetsDepreciationScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Khấu Hao TSCĐ",
            key: "view-fixed-assets-depreciation-schedule",
            route: "/templates/fixed-assets-depreciation-schedule/:id/view",
            component: <FixedAssetsDepreciationScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Bảng Khấu Hao TSCĐ",
            key: "edit-fixed-assets-depreciation-schedule",
            route: "/templates/fixed-assets-depreciation-schedule/:id/edit",
            component: <FixedAssetsDepreciationScheduleDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Tài Sản Cố Định",
            key: "fixed-assets-inventory-summary",
            route: `/templates/fixed-assets-inventory-summary`,
            component: <FixedAssetsInventorySummary />,
            authority: [],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Tài Sản Cố Định",
            key: "create-fixed-assets-inventory-summary",
            route: "/templates/fixed-assets-inventory-summary/create",
            component: <FixedAssetsInventorySummaryDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Tài Sản Cố Định",
            key: "view-fixed-assets-inventory-summary",
            route: "/templates/fixed-assets-inventory-summary/:id/view",
            component: <FixedAssetsInventorySummaryDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Biên Bản Tổng Hợp Kiểm Kê Tài Sản Cố Định",
            key: "edit-fixed-assets-inventory-summary",
            route: "/templates/fixed-assets-inventory-summary/:id/edit",
            component: <FixedAssetsInventorySummaryDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
        ],
      },
      {
        type: "collapse",
        name: "Phụ Lục III",
        key: "appendix-III",
        authority: [SUPER_ADMIN, ADMIN],
        collapse: [
          {
            name: "Nhật Ký - Sổ Cái (S01-DN)",
            key: "general-journal-ledger",
            route: `/templates/general-journal-ledger`,
            component: <GeneralJournalLedger />,
            authority: [],
          },
          {
            name: "Xem Nhật Ký - Sổ Cái",
            key: "view-general-journal-ledger",
            route: "/templates/general-journal-ledger/:id/view",
            component: <GeneralJournalLedgerDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Chứng Từ Ghi Sổ (S02a-DN)",
            key: "accounting-vouchers",
            route: `/templates/accounting-vouchers`,
            component: <AccountingVouchers />,
            authority: [],
          },
          {
            name: "Tạo Chứng Từ Ghi Sổ",
            key: "create-accounting-vouchers",
            route: `/templates/accounting-vouchers/create`,
            component: <AccountingVouchersDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Chứng Từ Ghi Sổ",
            key: "view-accounting-vouchers",
            route: `/templates/accounting-vouchers/:id/view`,
            component: <AccountingVouchersDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Chứng Từ Ghi Sổ",
            key: "edit-accounting-vouchers",
            route: `/templates/accounting-vouchers/:id/edit`,
            component: <AccountingVouchersDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Đăng Ký Chứng Từ Ghi Sổ (S02b-DN)",
            key: "accounting-document-register",
            route: `/templates/accounting-document-register`,
            component: <AccountingDocumentRegister />,
            authority: [],
          },
          {
            name: "Xem Sổ Đăng Ký Chứng Từ Ghi Sổ (S02b-DN)",
            key: "view-accounting-document-register",
            route: `/templates/accounting-document-register/view`,
            component: <AccountingDocumentRegisterDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Cái Ít Cột (S02c1-DN)",
            key: "subsidiary-ledger",
            route: `/templates/subsidiary-ledger`,
            component: <SubsidiaryLedgerS02c1 />,
            authority: [],
          },
          {
            name: "Xem Sổ Cái Ít Cột (S02c1-DN)",
            key: "view-subsidiary-ledger",
            route: `/templates/subsidiary-ledger/view`,
            component: <SubsidiaryLedgerS02c1Detail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Cái Nhiều Cột (S02c2-DN)",
            key: "general-ledger",
            route: `/templates/general-ledger`,
            component: <GeneralLedgerS02c2 />,
            authority: [],
          },
          {
            name: "Xem Sổ Cái Nhiều Cột (S02c2-DN)",
            key: "view-general-ledger",
            route: `/templates/general-ledger/view`,
            component: <GeneralLedgerS02c2Detail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Nhật Ký Chung",
            key: "journal-entries",
            route: `/templates/journal-entries`,
            component: <JournalEntries />,
            authority: [],
          },
          {
            name: "Xem Sổ Nhật Ký Chung",
            key: "view-journal-entries",
            route: `/templates/journal-entries/view`,
            component: <JournalEntriesDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Nhật Ký Thu Tiền",
            key: "cash-receipts-journal",
            route: `/templates/cash-receipts-journal`,
            component: <CashReceiptsJournal />,
            authority: [],
          },
          {
            name: "Xem Sổ Nhật Ký Thu Tiền",
            key: "view-cash-receipts-journal",
            route: `/templates/cash-receipts-journal/view`,
            component: <CashReceiptsJournalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Nhật Ký Chi Tiền",
            key: "cash-book",
            route: `/templates/cash-book`,
            component: <CashBook />,
            authority: [],
          },
          {
            name: "Xem Sổ Nhật Ký Chi Tiền",
            key: "view-cash-book",
            route: `/templates/cash-book/view`,
            component: <CashBookDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Nhật Ký Mua Hàng",
            key: "purchases-journal",
            route: `/templates/purchases-journal`,
            component: <PurchasesJournal />,
            authority: [],
          },
          {
            name: "Xem Sổ Nhật Ký Mua Hàng",
            key: "view-purchases-journal",
            route: `/templates/purchases-journal/view`,
            component: <PurchasesJournalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Nhật Ký Bán Hàng",
            key: "sales-journal",
            route: `/templates/sales-journal`,
            component: <SalesJournal />,
            authority: [],
          },
          {
            name: "Xem Sổ Nhật Ký Bán Hàng",
            key: "view-sales-journal",
            route: `/templates/sales-journal/view`,
            component: <SalesJournalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sổ Cái (Dùng Cho Hình Thức Kế Toán Nhật Ký Chung)",
            key: "ledger-journal",
            route: `/templates/ledger-journal`,
            component: <LedgerJournal />,
            authority: [],
          },
          {
            name: "Chi tiết sổ cái",
            key: "ledger-journal",
            route: `/templates/ledger-journal/view`,
            component: <LedgerJournalDetail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Nhật Ký Chứng Từ Số 1",
            key: "journal-voucher-1",
            route: `/templates/journal-voucher-1`,
            component: <JournalVoucher1 />,
            authority: [],
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 1",
            key: "journal-voucher-1-view",
            route: `/templates/journal-voucher-1/view`,
            component: <JournalVoucher1Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Bảng Kê Số 1",
            key: "accounting-table-1",
            route: `/templates/accounting-table-1`,
            component: <AccountingTable1 />,
            authority: [],
          },
          {
            name: "Xem Bảng Kê Số 1",
            key: "accounting-table-1-view",
            route: `/templates/accounting-table-1/view`,
            component: <AccountingTable1Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Nhật Ký Chứng Từ Số 2",
            key: "journal-voucher-2",
            route: `/templates/journal-voucher-2`,
            component: <JournalVoucher2 />,
            authority: [],
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 2",
            key: "journal-voucher-2",
            route: `/templates/journal-voucher-2/view`,
            component: <JournalVoucher2Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Bảng Kê Số 2",
            key: "accounting-table-2",
            route: `/templates/accounting-table-2`,
            component: <AccountingTable2 />,
            authority: [],
          },
          {
            name: "Xem Bảng Kê Số 2",
            key: "accounting-table-2",
            route: `/templates/accounting-table-2/view`,
            component: <AccountingTable2Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Nhật Ký Chứng Từ Số 3",
            key: "journal-voucher-3",
            route: `/templates/journal-voucher-3`,
            component: <JournalVoucher3 />,
            authority: [],
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 3",
            key: "view-journal-voucher-3",
            route: `/templates/journal-voucher-3/view`,
            component: <JournalVoucher3Detail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Nhật Ký Chứng Từ Số 4",
            key: "journal-voucher-4",
            route: `/templates/journal-voucher-4`,
            component: <JournalVoucher4 />,
            authority: [],
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 4",
            key: "journal-voucher-4-view",
            route: `/templates/journal-voucher-4/view`,
            component: <JournalVoucher4Detail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Nhật Ký Chứng Từ Số 5",
            key: "journal-voucher-5",
            route: `/templates/journal-voucher-5`,
            component: <JournalVoucher5 />,
            authority: [],
          },
          {
            name: "Tạo Nhật Ký Chứng Từ Số 5",
            key: "journal-voucher-5-create",
            route: `/templates/journal-voucher-5/create`,
            component: <JournalVoucher5Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 5",
            key: "journal-voucher-5-view",
            route: `/templates/journal-voucher-5/view/:id`,
            component: <JournalVoucher5Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Sửa Nhật Ký Chứng Từ Số 5",
            key: "journal-voucher-5-edit",
            route: `/templates/journal-voucher-5/edit/:id`,
            component: <JournalVoucher5Detail />,
            hidden: true,
            authority: [],
          },
          {
            name: "Nhật Ký Chứng Từ Số 6",
            key: "journal-voucher-6",
            route: `/templates/journal-voucher-6`,
            component: <JournalVoucher6 />,
            authority: [],
          },

          {
            name: "Xem Nhật Ký Chứng Từ Số 6",
            key: "view-journal-voucher-6",
            route: `/templates/journal-voucher-6/view/:id`,
            component: <JournalVoucher6Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Nhật Ký Chứng Từ Số 6",
            key: "edit-journal-voucher-6",
            route: `/templates/journal-voucher-6/edit/:id`,
            component: <JournalVoucher6Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Nhật Ký Chứng Từ Số 7",
            key: "journal-voucher-7",
            route: `/templates/journal-voucher-7`,
            component: <JournalVoucher7 />,
            authority: [],
          },
          {
            name: "Tạo Nhật Ký Chứng Từ Số 7",
            key: "create-journal-voucher-7",
            route: `/templates/journal-voucher-7/create`,
            component: <JournalVoucher7Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 7",
            key: "view-journal-voucher-7",
            route: `/templates/journal-voucher-7/view/:id`,
            component: <JournalVoucher7Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Nhật Ký Chứng Từ Số 7",
            key: "edit-journal-voucher-7",
            route: `/templates/journal-voucher-7/edit/:id`,
            component: <JournalVoucher7Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Bảng Kê Số 3",
            key: "accounting-table-3",
            route: `/templates/accounting-table-3`,
            component: <AccountingTable3 />,
            authority: [],
          },
          {
            name: "Bảng Kê Số 4",
            key: "accounting-table-4",
            route: `/templates/accounting-table-4`,
            component: <AccountingTable4 />,
            authority: [],
          },
          {
            name: "Xem Chi Tiết Bảng Kê Số 4",
            key: "accounting-table-4-view",
            route: `/templates/accounting-table-4/view`,
            component: <AccountingTable4Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Chi tiết Bảng Kê Số 5",
            key: "accounting-table-5-detail",
            route: `/templates/accounting-table-5/detail/:id`,
            component: <AccountingTable5Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Bảng Kê Số 5",
            key: "accounting-table-5",
            route: `/templates/accounting-table-5`,
            component: <AccountingTable5 />,
            authority: [],
          },
          {
            name: "Chi tiết Bảng Kê Số 6",
            key: "accounting-table-6-detail",
            route: `/templates/accounting-table-6/detail/:id`,
            component: <AccountingTable6Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Bảng Kê Số 6",
            key: "accounting-table-6",
            route: `/templates/accounting-table-6`,
            component: <AccountingTable6 />,
            authority: [],
          },
          {
            name: "Bảng Kê Số 7",
            key: "accounting-table-7",
            route: `/templates/accounting-table-7`,
            component: <AccountingTable7 />,
            authority: [],
          },
          {
            name: "Bảng Kê Số 8",
            key: "accounting-table-8",
            route: `/templates/accounting-table-8`,
            component: <AccountingTable8 />,
            authority: [],
          },
          {
            name: "Bảng Kê Số 9",
            key: "accounting-table-9",
            route: `/templates/accounting-table-9`,
            component: <AccountingTable9 />,
            authority: [],
          },
          {
            name: "Bảng Kê Số 10",
            key: "accounting-table-10",
            route: `/templates/accounting-table-10`,
            component: <AccountingTable10 />,
            authority: [],
          },
          {
            name: "Tạo Bảng Kê Số 10",
            key: "create-accounting-table-10",
            route: `/templates/accounting-table-10/create`,
            component: <AccountingTable10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Bảng Kê Số 10",
            key: "view-accounting-table-10",
            route: `/templates/accounting-table-10/:id/view`,
            component: <AccountingTable10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Bảng Kê Số 10",
            key: "edit-accounting-table-10",
            route: `/templates/accounting-table-10/:id/edit`,
            component: <AccountingTable10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Nhật Ký Chứng Từ Số 8",
            key: "journal-voucher-8",
            route: `/templates/journal-voucher-8`,
            component: <JournalVoucher8 />,
            authority: [],
          },
          {
            name: "Tạo Nhật Ký Chứng Từ Số 8",
            key: "create-journal-voucher-8",
            route: `/templates/journal-voucher-8/create`,
            component: <JournalVoucher8Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 8",
            key: "view-journal-voucher-8",
            route: `/templates/journal-voucher-8/:id/view`,
            component: <JournalVoucher8Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Nhật Ký Chứng Từ Số 8",
            key: "edit-journal-voucher-8",
            route: `/templates/journal-voucher-8/:id/edit`,
            component: <JournalVoucher8Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Nhật Ký Chứng Từ Số 9",
            key: "journal-voucher-9",
            route: `/templates/journal-voucher-9`,
            component: <JournalVoucher9 />,
            authority: [],
          }, {
            name: "Tạo Nhật Ký Chứng Từ Số 9",
            key: "create-journal-voucher-9",
            route: `/templates/journal-voucher-9/create`,
            component: <JournalVoucher9Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Nhật Ký Chứng Từ Số 9",
            key: "view-journal-voucher-9",
            route: `/templates/journal-voucher-9/:id/view`,
            component: <JournalVoucher9Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Nhật Ký Chứng Từ Số 9",
            key: "edit-journal-voucher-9",
            route: `/templates/journal-voucher-9/:id/edit`,
            component: <JournalVoucher9Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Nhật Ký Chứng Từ Số 10",
            key: "journal-voucher-10",
            route: `/templates/journal-voucher-10`,
            component: <JournalVoucher10 />,
            authority: [],
          },{
            name: "Tạo Nhật ký Chứng từ số 10",
            key: "create-journal-voucher-10",
            route: `/templates/journal-voucher-10/create`,
            component: <JournalVoucher10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Nhật ký Chứng từ số 10",
            key: "view-journal-voucher-10",
            route: `/templates/journal-voucher-10/:id/view`,
            component: <JournalVoucher10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Nhật ký Chứng từ số 10",
            key: "edit-journal-voucher-10",
            route: `/templates/journal-voucher-10/:id/edit`,
            component: <JournalVoucher10Detail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Cái (Dùng Cho Hình Thức Nhật Ký - Chứng Từ)",
            key: "journal-voucher-system-ledger",
            route: `/templates/journal-voucher-system-ledger`,
            component: <JournalVoucherSystemLedger />,
            authority: [],
          },
           {
            name: "Tạo Sổ Cái (Nhật ký - Chứng từ)",
            key: "create-journal-voucher-system-ledger",
            route: `/templates/journal-voucher-system-ledger/create`,
            component: <JournalVoucherSystemLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Cái (Nhật ký - Chứng từ)",
            key: "view-journal-voucher-system-ledger",
            route: `/templates/journal-voucher-system-ledger/:id/view`,
            component: <JournalVoucherSystemLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Cái (Nhật ký - Chứng từ)",
            key: "edit-journal-voucher-system-ledger",
            route: `/templates/journal-voucher-system-ledger/:id/edit`,
            component: <JournalVoucherSystemLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Bảng Cân Đối Phát Sinh",
            key: "trial-balance",
            route: `/templates/trial-balance`,
            component: <TrialBalance />,
            authority: [],
          },
          {
            name: "Tạo Bảng Cân Đối Phát Sinh",
            key: "create-trial-balance",
            route: `/templates/trial-balance/create`,
            component: <TrialBalanceDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Bảng Cân Đối Phát Sinh",
            key: "view-trial-balance",
            route: `/templates/trial-balance/:id/view`,
            component: <TrialBalanceDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Bảng Cân Đối Phát Sinh",
            key: "edit-trial-balance",
            route: `/templates/trial-balance/:id/edit`,
            component: <TrialBalanceDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Quỹ Tiền Mặt",
            key: "cash-ledger",
            route: `/templates/cash-ledger`,
            component: <CashLedger />,
            authority: [],
          },
          {
            name: "Sổ Kế Toán Chi Tiết Quỹ Tiền Mặt",
            key: "petty-cash-book",
            route: `/templates/petty-cash-book`,
            component: <PettyCashBook />,
            authority: [],
          },
          {
            name: "Tạo Sổ Quỹ Tiền Mặt",
            key: "create-petty-cash-book",
            route: `/templates/petty-cash-book/create`,
            component: <PettyCashBookDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Quỹ Tiền Mặt",
            key: "view-petty-cash-book",
            route: `/templates/petty-cash-book/:id/view`,
            component: <PettyCashBookDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Quỹ Tiền Mặt",
            key: "edit-petty-cash-book",
            route: `/templates/petty-cash-book/:id/edit`,
            component: <PettyCashBookDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Tiền Gửi Không Kỳ Hạn",
            key: "demand-deposit",
            route: `/templates/demand-deposit`,
            component: <DemandDeposit />,
            authority: [],
          },
          {
            name: "Tạo Sổ Tiền Gửi Mới",
            key: "create-demand-deposit",
            route: `/templates/demand-deposit/create`,
            component: <DemandDepositDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Tiền Gửi Mới",
            key: "view-demand-deposit",
            route: `/templates/demand-deposit/:id/view`,
            component: <DemandDepositDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Tiền Gửi Mới",
            key: "edit-demand-deposit",
            route: `/templates/demand-deposit/:id/edit`,
            component: <DemandDepositDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Vật Liệu, Dụng Cụ (Sản Phẩm, Hàng Hóa)",
            key: "detailed-inventory-ledger",
            route: `/templates/detailed-inventory-ledger`,
            component: <DetailedInventoryLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Vật Tư",
            key: "create-detailed-inventory-ledger",
            route: `/templates/detailed-inventory-ledger/create`,
            component: <DetailedInventoryLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Chi Tiết Vật Tư",
            key: "view-detailed-inventory-ledger",
            route: `/templates/detailed-inventory-ledger/:id/view`,
            component: <DetailedInventoryLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Chi Tiết Vật Tư",
            key: "edit-detailed-inventory-ledger",
            route: `/templates/detailed-inventory-ledger/:id/edit`,
            component: <DetailedInventoryLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Bảng Tổng Hợp Chi Tiết Vật Liệu, Dụng Cụ, Sản Phẩm, Hàng Hóa",
            key: "summary-of-detailed",
            route: `/templates/summary-of-detailed`,
            component: <SummaryOfDetailed />,
            authority: [],
          },
          {
            name: "Tạo Bảng Tổng Hợp Chi Tiết",
            key: "create-summary-of-detailed",
            route: `/templates/summary-of-detailed/create`,
            component: <SummaryOfDetailedDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Bảng Tổng Hợp Chi Tiết",
            key: "view-summary-of-detailed",
            route: `/templates/summary-of-detailed/:id/view`,
            component: <SummaryOfDetailedDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Bảng Tổng Hợp Chi Tiết",
            key: "edit-summary-of-detailed",
            route: `/templates/summary-of-detailed/:id/edit`,
            component: <SummaryOfDetailedDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Thẻ Kho (Sổ Kho)",
            key: "bin-card",
            route: `/templates/bin-card`,
            component: <BinCard />,
            authority: [],
          },
           {
            name: "Thẻ Kho",
            key: "bin-card",
            route: `/templates/bin-card`,
            component: <BinCard />,
            hidden: true,
            authority: [],
          },
          {
            name: "Tạo Thẻ Kho",
            key: "create-bin-card",
            route: `/templates/bin-card/create`,
            component: <BinCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Thẻ Kho",
            key: "view-bin-card",
            route: `/templates/bin-card/:id/view`,
            component: <BinCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Thẻ Kho",
            key: "edit-bin-card",
            route: `/templates/bin-card/:id/edit`,
            component: <BinCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Tài Sản Cố Định",
            key: "fixed-assets-register",
            route: `/templates/fixed-assets-register`,
            component: <FixedAssetsRegister />,
            authority: [],
          },
          {
            name: "Tạo Sổ Tài Sản Cố Định",
            key: "create-fixed-assets-register",
            route: `/templates/fixed-assets-register/create`,
            component: <FixedAssetsRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ tài Sản Cố Định",
            key: "view-fixed-assets-register",
            route: `/templates/fixed-assets-register/:id/view`,
            component: <FixedAssetsRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Tài Sản Cố Định",
            key: "edit-fixed-assets-register",
            route: `/templates/fixed-assets-register/:id/edit`,
            component: <FixedAssetsRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Tài Sản Cố Định Và Công Cụ, Dụng Cụ Tại Nơi Sử Dụng",
            key: "equipment-ledger",
            route: `/templates/equipment-ledger`,
            component: <EquipmentLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ Theo Dõi TSCĐ Và Công Cụ",
            key: "create-equipment-ledger",
            route: `/templates/equipment-ledger/create`,
            component: <EquipmentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Theo Dõi TSCĐ Và Công Cụ",
            key: "view-equipment-ledger",
            route: `/templates/equipment-ledger/:id/view`,
            component: <EquipmentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Theo Dõi TSCĐ Và Công Cụ",
            key: "edit-equipment-ledger",
            route: `/templates/equipment-ledger/:id/edit`,
            component: <EquipmentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Thẻ Tài Sản Cố Định",
            key: "asset-card",
            route: `/templates/asset-card`,
            component: <AssetCard />,
            authority: [],
          },
          {
            name: "Tạo Thẻ Tài Sản Cố Định",
            key: "create-asset-card",
            route: `/templates/asset-card/create`,
            component: <AssetCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Thẻ Tài Sản Cố Định",
            key: "view-asset-card",
            route: `/templates/asset-card/:id/view`,
            component: <AssetCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Thẻ Tài Sản Cố Định",
            key: "edit-asset-card",
            route: `/templates/asset-card/:id/edit`,
            component: <AssetCardDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Thanh Toán Với Người Mua (Người Bán)",
            key: "customer-payment-details-ledger",
            route: `/templates/customer-payment-details-ledger`,
            component: <CustomerPaymentDetailsLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Thanh Toán Với Người Mua (Người Bán)",
            key: "create-customer-payment-details-ledger",
            route: `/templates/customer-payment-details-ledger/create`,
            component: <CustomerPaymentDetailsLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Chi Tiết Thanh Toán Với Người Mua (Người Bán)",
            key: "view-customer-payment-details-ledger",
            route: `/templates/customer-payment-details-ledger/:id/view`,
            component: <CustomerPaymentDetailsLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Chi Tiết Thanh Toán Với Người Mua (Người Bán)",
            key: "edit-customer-payment-details-ledger",
            route: `/templates/customer-payment-details-ledger/:id/edit`,
            component: <CustomerPaymentDetailsLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Thanh Toán Với Người Mua (Người Bán) Bằng Ngoại Tệ",
            key: "subsidiary-ledger-fc-payments",
            route: `/templates/subsidiary-ledger-fc-payments`,
            component: <SubsidiaryLedgerFcPayments />,
            authority: [],
          },
          {
            name: "Tạo Sổ chi tiết thanh toán với người mua (người bán) bằng ngoại tệ",
            key: "create-subsidiary-ledger-fc-payments",
            route: `/templates/subsidiary-ledger-fc-payments/create`,
            component: <SubsidiaryLedgerFcPaymentsDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ chi tiết thanh toán với người mua (người bán) bằng ngoại tệ",
            key: "view-subsidiary-ledger-fc-payments",
            route: `/templates/subsidiary-ledger-fc-payments/:id/view`,
            component: <SubsidiaryLedgerFcPaymentsDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ chi tiết thanh toán với người mua (người bán) bằng ngoại tệ",
            key: "edit-subsidiary-ledger-fc-payments",
            route: `/templates/subsidiary-ledger-fc-payments/:id/edit`,
            component: <SubsidiaryLedgerFcPaymentsDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Thanh Toán Bằng Ngoại Tệ",
            key: "foreign-currency-payment-ledger",
            route: `/templates/foreign-currency-payment-ledger`,
            component: <ForeignCurrencyPaymentLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ theo dõi thanh toán bằng ngoại tệ",
            key: "foreign-currency-payment-ledger",
            route: `/templates/foreign-currency-payment-ledger/create`,
            component: <ForeignCurrencyPaymentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ theo dõi thanh toán bằng ngoại tệ",
            key: "foreign-currency-payment-ledger",
            route: `/templates/foreign-currency-payment-ledger/:id/view`,
            component: <ForeignCurrencyPaymentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ theo dõi thanh toán bằng ngoại tệ",
            key: "foreign-currency-payment-ledger",
            route: `/templates/foreign-currency-payment-ledger/:id/edit`,
            component: <ForeignCurrencyPaymentLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Vay Nợ",
            key: "loan-detail-ledger",
            route: `/templates/loan-detail-ledger`,
            component: <LoanDetailLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ chi tiết vay nợ",
            key: "loan-detail-ledger",
            route: `/templates/loan-detail-ledger/create`,
            component: <LoanDetailLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ chi tiết vay nợ",
            key: "loan-detail-ledger",
            route: `/templates/loan-detail-ledger/:id/view`,
            component: <LoanDetailLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ chi tiết vay nợ",
            key: "loan-detail-ledger",
            route: `/templates/loan-detail-ledger/:id/edit`,
            component: <LoanDetailLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Bán Hàng",
            key: "sales-detailed-ledger",
            route: `/templates/sales-detailed-ledger`,
            component: <SalesDetailedLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ chi tiết bán hàng",
            key: "sales-detailed-ledger",
            route: `/templates/sales-detailed-ledger/create`,
            component: <SalesDetailedLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ chi tiết bán hàng",
            key: "sales-detailed-ledger",
            route: `/templates/sales-detailed-ledger/:id/view`,
            component: <SalesDetailedLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ chi tiết bán hàng",
            key: "sales-detailed-ledger",
            route: `/templates/sales-detailed-ledger/:id/edit`,
            component: <SalesDetailedLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Chi Phí Sản Xuất, Kinh Doanh",
            key: "cost-ledger",
            route: `/templates/cost-ledger`,
            component: <CostLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Chi Phí Sản Xuất, Kinh Doanh",
            key: "cost-ledger",
            route: `/templates/cost-ledger/create`,
            component: <CostLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Chi Tiết Chi Phí Sản Xuất, Kinh Doanh",
            key: "cost-ledger",
            route: `/templates/cost-ledger/:id/view`,
            component: <CostLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Chi Tiết Chi Phí Sản Xuất, Kinh Doanh",
            key: "cost-ledger",
            route: `/templates/cost-ledger/:id/edit`,
            component: <CostLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Thẻ Tính Giá Thành Sản Phẩm, Dịch Vụ",
            key: "cost-estimate-sheet",
            route: `/templates/cost-estimate-sheet`,
            component: <CostEstimateSheet />,
            authority: [],
          },
          {
            name: "Tạo Thẻ tính giá thành sản phẩm, dịch vụ",
            key: "cost-estimate-sheet",
            route: `/templates/cost-estimate-sheet/create`,
            component: <CostEstimateSheetDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Thẻ tính giá thành sản phẩm, dịch vụ",
            key: "cost-estimate-sheet",
            route: `/templates/cost-estimate-sheet/:id/view`,
            component: <CostEstimateSheetDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Thẻ tính giá thành sản phẩm, dịch vụ",
            key: "cost-estimate-sheet",
            route: `/templates/cost-estimate-sheet/:id/edit`,
            component: <CostEstimateSheetDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Các Tài Khoản",
            key: "subsidiary-ledgers",
            route: `/templates/subsidiary-ledgers`,
            component: <SubsidiaryLedgers />,
            authority: [],
          },
          {
            name: "Sổ Chi Tiết Các Tài Khoản",
            key: "subsidiary-ledgers",
            route: `/templates/subsidiary-ledgers/create`,
            component: <SubsidiaryLedgersDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Các Tài Khoản",
            key: "subsidiary-ledgers",
            route: `/templates/subsidiary-ledgers/:id/view`,
            component: <SubsidiaryLedgersDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Các Tài Khoản",
            key: "subsidiary-ledgers",
            route: `/templates/subsidiary-ledgers/:id/edit`,
            component: <SubsidiaryLedgersDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "joint-venture-investment-detailed-record",
            route: `/templates/joint-venture-investment-detailed-record`,
            component: <JointVentureInvestmentDetailedRecord />,
            authority: [],
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "joint-venture-investment-detailed-record",
            route: `/templates/joint-venture-investment-detailed-record/create`,
            component: <JointVentureInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "joint-venture-investment-detailed-record",
            route: `/templates/joint-venture-investment-detailed-record/:id/view`,
            component: <JointVentureInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "joint-venture-investment-detailed-record",
            route: `/templates/joint-venture-investment-detailed-record/:id/edit`,
            component: <JointVentureInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "investment-joint-venture-differential-allocation-record",
            route: `/templates/investment-joint-venture-differential-allocation-record`,
            component: <InvestmentJointVentureDifferentialAllocationRecord />,
            authority: [],
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "investment-joint-venture-differential-allocation-record",
            route: `/templates/investment-joint-venture-differential-allocation-record/create`,
            component: <InvestmentJointVentureDifferentialAllocationRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "investment-joint-venture-differential-allocation-record",
            route: `/templates/investment-joint-venture-differential-allocation-record/:id/view`,
            component: <InvestmentJointVentureDifferentialAllocationRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Doanh",
            key: "investment-joint-venture-differential-allocation-record",
            route: `/templates/investment-joint-venture-differential-allocation-record/:id/edit`,
            component: <InvestmentJointVentureDifferentialAllocationRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "sa-investment-detailed-record",
            route: `/templates/sa-investment-detailed-record`,
            component: <SaInvestmentDetailedRecord />,
            authority: [],
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "sa-investment-detailed-record",
            route: `/templates/sa-investment-detailed-record/create`,
            component: <SaInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "sa-investment-detailed-record",
            route: `/templates/sa-investment-detailed-record/:id/view`,
            component: <SaInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Kế Toán Chi Tiết Theo Dõi Các Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "sa-investment-detailed-record",
            route: `/templates/sa-investment-detailed-record/:id/edit`,
            component: <SaInvestmentDetailedRecordDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "investment-difference-allocation-register",
            route: `/templates/investment-difference-allocation-register`,
            component: <InvestmentDifferenceAllocationRegister />,
            authority: [],
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "investment-difference-allocation-register",
            route: `/templates/investment-difference-allocation-register/create`,
            component: <InvestmentDifferenceAllocationRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "investment-difference-allocation-register",
            route: `/templates/investment-difference-allocation-register/:id/view`,
            component: <InvestmentDifferenceAllocationRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Theo Dõi Phân Bổ Các Khoản Chênh Lệch Phát Sinh Khi Mua Khoản Đầu Tư Vào Công Ty Liên Kết",
            key: "investment-difference-allocation-register",
            route: `/templates/investment-difference-allocation-register/:id/edit`,
            component: <InvestmentDifferenceAllocationRegisterDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Phát Hành Cổ Phiếu",
            key: "stock-ledger",
            route: `/templates/stock-ledger`,
            component: <StockLedger />,
            authority: [],
          },
          {
            name: "Sổ Chi Tiết Phát Hành Cổ Phiếu",
            key: "stock-ledger",
            route: `/templates/stock-ledger/create`,
            component: <StockLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Phát Hành Cổ Phiếu",
            key: "stock-ledger",
            route: `/templates/stock-ledger/:id/view`,
            component: <StockLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Phát Hành Cổ Phiếu",
            key: "stock-ledger",
            route: `/templates/stock-ledger/:id/edit`,
            component: <StockLedgerDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sổ Chi Tiết Cổ Phiếu Mua Lại Của Chính Mình",
            key: "register-own-shares-purchased",
            route: `/templates/register-own-shares-purchased`,
            component: <RegisterOwnSharesPurchased />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Cổ Phiếu Mua Lại Của Chính Mình",
            key: "register-own-shares-purchased-create",
            route: `/templates/register-own-shares-purchased/create`,
            component: <RegisterOwnSharesPurchasedDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Xem Sổ Chi Tiết Cổ Phiếu Mua Lại Của Chính Mình",
            key: "register-own-shares-purchased-view",
            route: `/templates/register-own-shares-purchased/:id/view`,
            component: <RegisterOwnSharesPurchasedDetail />,
            authority: [],
            hidden: true,
          },
          {
            name: "Sửa Sổ Chi Tiết Cổ Phiếu Mua Lại Của Chính Mình",
            key: "register-own-shares-purchased-edit",
            route: `/templates/register-own-shares-purchased/:id/edit`,
            component: <RegisterOwnSharesPurchasedDetail />,
            authority: [],
            hidden: true,
          },
          ///
          {
            name: "Sổ Chi Tiết Đầu Tư Chứng Khoán",
            key: "securities-portfolio",
            route: `/templates/securities-portfolio`,
            component: <SecuritiesPortfolio />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Đầu Tư Chứng Khoán",
            key: "create-securities-portfolio",
            route: "/templates/securities-portfolio/create",
            component: <SecuritiesPortfolioDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Chi Tiết Đầu Tư Chứng Khoán",
            key: "view-securities-portfolio",
            route: "/templates/securities-portfolio/:id/view",
            component: <SecuritiesPortfolioDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Chi Tiết Đầu Tư Chứng Khoán",
            key: "edit-securities-portfolio",
            route: "/templates/securities-portfolio/:id/edit",
            component: <SecuritiesPortfolioDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///
          {
            name: "Sổ Theo Dõi Chi Tiết Vốn Đầu Tư Của Chủ Sở Hữu (TK 411)",
            key: "detailed-ledger-owners-capital",
            route: `/templates/detailed-ledger-owners-capital`,
            component: <DetailedLedgerOwnersCapital />,
            authority: [],
          },
          {
            name: "Tạo Sổ Theo Dõi Chi Tiết Vốn Đầu Tư Của Chủ Sở Hữu (TK 411)",
            key: "create-detailed-ledger-owners-capital",
            route: "/templates/detailed-ledger-owners-capital/create",
            component: <DetailedLedgerOwnersCapitalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Theo Dõi Chi Tiết Vốn Đầu Tư Của Chủ Sở Hữu (TK 411)",
            key: "view-detailed-ledger-owners-capital",
            route: "/templates/detailed-ledger-owners-capital/:id/view",
            component: <DetailedLedgerOwnersCapitalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Theo Dõi Chi Tiết Vốn Đầu Tư Của Chủ Sở Hữu (TK 411)",
            key: "edit-detailed-ledger-owners-capital",
            route: "/templates/detailed-ledger-owners-capital/:id/edit",
            component: <DetailedLedgerOwnersCapitalDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///
          {
            name: "Sổ Chi Phí Đầu Tư Xây Dựng",
            key: "project-cost-ledger",
            route: `/templates/project-cost-ledger`,
            component: <ProjectCostLedger />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Phí Đầu Tư Xây Dựng",
            key: "create-project-cost-ledger",
            route: "/templates/project-cost-ledger/create",
            component: <ProjectCostLedgerDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Chi Phí Đầu Tư Xây Dựng",
            key: "view-project-cost-ledger",
            route: "/templates/project-cost-ledger/:id/view",
            component: <ProjectCostLedgerDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Chi Phí Đầu Tư Xây Dựng",
            key: "edit-project-cost-ledger",
            route: "/templates/project-cost-ledger/:id/edit",
            component: <ProjectCostLedgerDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///
          {
            name: "Sổ Theo Dõi Thuế Giá Trị Gia Tăng",
            key: "value-added-tax-filing",
            route: `/templates/value-added-tax-filing`,
            component: <ValueAddedTaxFiling />,
            authority: [],
          },
          {
            name: "Tạo Sổ Theo Dõi Thuế Giá Trị Gia Tăng",
            key: "create-value-added-tax-filing",
            route: "/templates/value-added-tax-filing/create",
            component: <ValueAddedTaxFilingDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Theo Dõi Thuế Giá Trị Gia Tăng",
            key: "view-value-added-tax-filing",
            route: "/templates/value-added-tax-filing/:id/view",
            component: <ValueAddedTaxFilingDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Theo Dõi Thuế Giá Trị Gia Tăng",
            key: "edit-value-added-tax-filing",
            route: "/templates/value-added-tax-filing/:id/edit",
            component: <ValueAddedTaxFilingDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///
          {
            name: "Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Hoàn Lại",
            key: "value-added-tax-refund",
            route: `/templates/value-added-tax-refund`,
            component: <ValueAddedTaxRefund />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Hoàn Lại",
            key: "create-value-added-tax-refund",
            route: "/templates/value-added-tax-refund/create",
            component: <ValueAddedTaxRefundDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Hoàn Lại",
            key: "view-value-added-tax-refund",
            route: "/templates/value-added-tax-refund/:id/view",
            component: <ValueAddedTaxRefundDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Hoàn Lại",
            key: "edit-value-added-tax-refund",
            route: "/templates/value-added-tax-refund/:id/edit",
            component: <ValueAddedTaxRefundDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          ///
          {
            name: "Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Miễn Giảm",
            key: "detail-ledger-vat-exemption-reduction",
            route: `/templates/detail-ledger-vat-exemption-reduction`,
            component: <DetailLedgerVatExemptionReduction />,
            authority: [],
          },
          {
            name: "Tạo Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Miễn Giảm",
            key: "create-detail-ledger-vat-exemption-reduction",
            route: "/templates/detail-ledger-vat-exemption-reduction/create",
            component: <DetailLedgerVatExemptionReductionDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Xem Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Miễn Giảm",
            key: "view-detail-ledger-vat-exemption-reduction",
            route: "/templates/detail-ledger-vat-exemption-reduction/:id/view",
            component: <DetailLedgerVatExemptionReductionDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
          {
            name: "Sửa Sổ Chi Tiết Thuế Giá Trị Gia Tăng Được Miễn Giảm",
            key: "edit-detail-ledger-vat-exemption-reduction",
            route: "/templates/detail-ledger-vat-exemption-reduction/:id/edit",
            component: <DetailLedgerVatExemptionReductionDetail />,
            hidden: true,
            authority: [ADMIN, USER],
          },
        ],
      },
    ],
  },
];
export { mainRoute };
